if (
    ((window.theme = window.theme || {}),
    (window.slate = window.slate || {}),
    (theme.Sections = function () {
        (this.constructors = {}),
            (this.instances = []),
            $(document)
                .on('shopify:section:load', this._onSectionLoad.bind(this))
                .on('shopify:section:unload', this._onSectionUnload.bind(this))
                .on('shopify:section:select', this._onSelect.bind(this))
                .on('shopify:section:deselect', this._onDeselect.bind(this))
                .on('shopify:block:select', this._onBlockSelect.bind(this))
                .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
    }),
    (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function (t, e) {
            var i = $(t),
                s = i.attr('data-section-id'),
                a = i.attr('data-section-type');
            if (((e = e || this.constructors[a]), !_.isUndefined(e))) {
                var n = _.assignIn(new e(t), { id: s, type: a, container: t });
                this.instances.push(n);
            }
        },
        _onSectionLoad: function (t) {
            var e = $('[data-section-id]', t.target)[0];
            e && this._createInstance(e), AOS && AOS.refreshHard();
        },
        _loadSubSections: function () {
            AOS && AOS.refreshHard();
        },
        _onSectionUnload: function (t) {
            this.instances = _.filter(this.instances, function (e) {
                var i = e.id === t.detail.sectionId;
                return i && _.isFunction(e.onUnload) && e.onUnload(t), !i;
            });
        },
        _onSelect: function (t) {
            var e = _.find(this.instances, function (e) {
                return e.id === t.detail.sectionId;
            });
            !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t);
        },
        _onDeselect: function (t) {
            var e = _.find(this.instances, function (e) {
                return e.id === t.detail.sectionId;
            });
            !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t);
        },
        _onBlockSelect: function (t) {
            var e = _.find(this.instances, function (e) {
                return e.id === t.detail.sectionId;
            });
            !_.isUndefined(e) &&
                _.isFunction(e.onBlockSelect) &&
                e.onBlockSelect(t);
        },
        _onBlockDeselect: function (t) {
            var e = _.find(this.instances, function (e) {
                return e.id === t.detail.sectionId;
            });
            !_.isUndefined(e) &&
                _.isFunction(e.onBlockDeselect) &&
                e.onBlockDeselect(t);
        },
        register: function (t, e) {
            (this.constructors[t] = e),
                $('[data-section-type=' + t + ']').each(
                    function (t, i) {
                        this._createInstance(i, e);
                    }.bind(this)
                );
        },
    })),
    (window.slate = window.slate || {}),
    (slate.rte = {
        wrapTable: function () {
            $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
        },
        iframeReset: function () {
            var t = $(
                    '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
                ),
                e = t.add('.rte iframe#admin_bar_iframe');
            t.each(function () {
                $(this).wrap('<div class="video-wrapper"></div>');
            }),
                e.each(function () {
                    this.src = this.src;
                });
        },
    }),
    (window.slate = window.slate || {}),
    (slate.a11y = {
        pageLinkFocus: function (t) {
            var e = 'js-focus-hidden';
            t.first()
                .attr('tabIndex', '-1')
                .focus()
                .addClass(e)
                .one('blur', function () {
                    t.first().removeClass(e).removeAttr('tabindex');
                });
        },
        focusHash: function () {
            var t = window.location.hash;
            t &&
                document.getElementById(t.slice(1)) &&
                this.pageLinkFocus($(t));
        },
        bindInPageLinks: function () {
            $('a[href*=#]').on(
                'click',
                function (t) {
                    this.pageLinkFocus($(t.currentTarget.hash));
                }.bind(this)
            );
        },
        trapFocus: function (t) {
            var e = t.namespace ? 'focusin.' + t.namespace : 'focusin';
            t.$elementToFocus || (t.$elementToFocus = t.$container),
                t.$container.attr('tabindex', '-1'),
                t.$elementToFocus.focus(),
                $(document).on(e, function (e) {
                    t.$container[0] === e.target ||
                        t.$container.has(e.target).length ||
                        t.$container.focus();
                });
        },
        removeTrapFocus: function (t) {
            var e = t.namespace ? 'focusin.' + t.namespace : 'focusin';
            t.$container &&
                t.$container.length &&
                t.$container.removeAttr('tabindex'),
                $(document).off(e);
        },
    }),
    (theme.Currency = (function () {
        var t = '${{amount}}';
        return {
            formatMoney: function (e, i) {
                'string' == typeof e && (e = e.replace('.', ''));
                var s = '',
                    a = /\{\{\s*(\w+)\s*\}\}/,
                    n = i || t;
                function o(t, e, i, s) {
                    if (
                        ((i = i || ','), (s = s || '.'), isNaN(t) || null === t)
                    )
                        return 0;
                    var a = (t = (t / 100).toFixed(e)).split('.');
                    return (
                        a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + i) +
                        (a[1] ? s + a[1] : '')
                    );
                }
                switch (n.match(a)[1]) {
                    case 'amount':
                        s = o(e, 2);
                        break;
                    case 'amount_no_decimals':
                        s = o(e, 0);
                        break;
                    case 'amount_with_comma_separator':
                        s = o(e, 2, '.', ',');
                        break;
                    case 'amount_no_decimals_with_comma_separator':
                        s = o(e, 0, '.', ',');
                        break;
                    case 'amount_no_decimals_with_space_separator':
                        s = o(e, 0, ' ');
                        break;
                    case 'amount_with_apostrophe_separator':
                        s = o(e, 2, "'");
                }
                return n.replace(a, s);
            },
        };
    })()),
    (theme.Images = (function () {
        return {
            preload: function (t, e) {
                'string' == typeof t && (t = [t]);
                for (var i = 0; i < t.length; i++) {
                    var s = t[i];
                    this.loadImage(this.getSizedImageUrl(s, e));
                }
            },
            loadImage: function (t) {
                new Image().src = t;
            },
            switchImage: function (t, e, i) {
                var s = this.imageSize(e.src),
                    a = this.getSizedImageUrl(t.src, s);
                i ? i(a, t, e) : (e.src = a);
            },
            imageSize: function (t) {
                var e = (t = t || '').match(
                    /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
                );
                return null === e ? null : e[1];
            },
            getSizedImageUrl: function (t, e) {
                if (null === e) return t;
                if ('master' === e) return this.removeProtocol(t);
                var i = t.match(
                    /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
                );
                if (null !== i) {
                    var s = t.split(i[0]),
                        a = i[0];
                    return this.removeProtocol(s[0] + '_' + e + a);
                }
                return null;
            },
            removeProtocol: function (t) {
                return t.replace(/http(s)?:/, '');
            },
        };
    })()),
    (slate.Variants = (function () {
        function t(t) {
            (this.$container = t.$container),
                (this.product = t.product),
                (this.singleOptionSelector = t.singleOptionSelector),
                (this.originalSelectorId = t.originalSelectorId),
                (this.enableHistoryState = t.enableHistoryState),
                (this.currentVariant = this._getVariantFromOptions()),
                $(this.singleOptionSelector, this.$container).on(
                    'change',
                    this._onSelectChange.bind(this)
                );
        }
        return (
            (t.prototype = _.assignIn({}, t.prototype, {
                _getCurrentOptions: function () {
                    var t = _.map(
                        $(this.singleOptionSelector, this.$container),
                        function (t) {
                            var e = $(t),
                                i = e.attr('type'),
                                s = {};
                            return 'radio' === i || 'checkbox' === i
                                ? !!e[0].checked &&
                                      ((s.value = e.val()),
                                      (s.index = e.data('index')),
                                      s)
                                : ((s.value = e.val()),
                                  (s.index = e.data('index')),
                                  s);
                        }
                    );
                    return (t = _.compact(t));
                },
                _getVariantFromOptions: function () {
                    var t = this._getCurrentOptions(),
                        e = this.product.variants;
                    return _.find(e, function (e) {
                        return t.every(function (t) {
                            return _.isEqual(e[t.index], t.value);
                        });
                    });
                },
                _onSelectChange: function () {
                    var t = this._getVariantFromOptions();
                    this.$container.trigger({
                        type: 'variantChange',
                        variant: t,
                    }),
                        t &&
                            (this._updateMasterSelect(t),
                            this._updateImages(t),
                            this._updatePrice(t),
                            this._updateSKU(t),
                            (this.currentVariant = t),
                            this.enableHistoryState &&
                                this._updateHistoryState(t));
                },
                _updateImages: function (t) {
                    var e = t.featured_image || {},
                        i = this.currentVariant.featured_image || {};
                    t.featured_image &&
                        e.src !== i.src &&
                        this.$container.trigger({
                            type: 'variantImageChange',
                            variant: t,
                        });
                },
                _updatePrice: function (t) {
                    (t.price === this.currentVariant.price &&
                        t.compare_at_price ===
                            this.currentVariant.compare_at_price) ||
                        this.$container.trigger({
                            type: 'variantPriceChange',
                            variant: t,
                        });
                },
                _updateSKU: function (t) {
                    t.sku !== this.currentVariant.sku &&
                        this.$container.trigger({
                            type: 'variantSKUChange',
                            variant: t,
                        });
                },
                _updateHistoryState: function (t) {
                    if (history.replaceState && t) {
                        var e =
                            window.location.protocol +
                            '//' +
                            window.location.host +
                            window.location.pathname +
                            '?variant=' +
                            t.id;
                        window.history.replaceState({ path: e }, '', e);
                    }
                },
                _updateMasterSelect: function (t) {
                    $(this.originalSelectorId, this.$container).val(t.id);
                },
            })),
            t
        );
    })()),
    (window.Drawers = (function () {
        var t = function (t, e, i) {
            var s = {
                close: '.js-drawer-close',
                open: '.js-drawer-open-' + e,
                openClass: 'js-drawer-open',
                dirOpenClass: 'js-drawer-open-' + e,
            };
            if (
                ((this.nodes = {
                    $parent: $('body, html'),
                    $page: $('.page-element'),
                    $moved: $('.is-moved-by-drawer'),
                }),
                (this.config = $.extend(s, i)),
                (this.position = e),
                (this.$drawer = $('#' + t)),
                (this.$open = $(this.config.open)),
                !this.$drawer.length)
            )
                return !1;
            (this.drawerIsOpen = !1), this.init();
        };
        return (
            (t.prototype.init = function () {
                this.$open.attr('aria-expanded', 'false'),
                    this.$open.on('click', $.proxy(this.open, this)),
                    this.$drawer
                        .find(this.config.close)
                        .on('click', $.proxy(this.close, this));
            }),
            (t.prototype.open = function (t) {
                var e = !1;
                if (!this.drawerIsOpen) {
                    if (
                        (this.$open.addClass(this.config.openClass),
                        t ? t.preventDefault() : (e = !0),
                        t &&
                            t.stopPropagation &&
                            (t.stopPropagation(),
                            (this.$activeSource = $(t.currentTarget))),
                        this.drawerIsOpen && !e)
                    )
                        return this.close();
                    this.nodes.$moved.addClass('is-transitioning'),
                        this.$drawer.prepareTransition(),
                        this.nodes.$parent.addClass(
                            this.config.openClass +
                                ' ' +
                                this.config.dirOpenClass
                        ),
                        (this.drawerIsOpen = !0),
                        slate.a11y.trapFocus({
                            $container: this.$drawer,
                            namespace: 'drawer_focus',
                        }),
                        this.config.onDrawerOpen &&
                            'function' == typeof this.config.onDrawerOpen &&
                            (e || this.config.onDrawerOpen()),
                        this.$activeSource &&
                            this.$activeSource.attr('aria-expanded') &&
                            this.$activeSource.attr('aria-expanded', 'true'),
                        this.bindEvents();
                }
            }),
            (t.prototype.close = function () {
                this.drawerIsOpen &&
                    (this.$open.removeClass(this.config.openClass),
                    $(document.activeElement).trigger('blur'),
                    this.nodes.$moved.prepareTransition({
                        disableExisting: !0,
                    }),
                    this.$drawer.prepareTransition({ disableExisting: !0 }),
                    this.nodes.$parent.removeClass(
                        this.config.dirOpenClass + ' ' + this.config.openClass
                    ),
                    (this.drawerIsOpen = !1),
                    slate.a11y.removeTrapFocus({
                        $container: this.$drawer,
                        namespace: 'drawer_focus',
                    }),
                    this.$activeSource &&
                        this.$activeSource.attr('aria-expanded') &&
                        this.$activeSource.attr('aria-expanded', 'false'),
                    this.unbindEvents());
            }),
            (t.prototype.bindEvents = function () {
                this.nodes.$page.on('touchmove.drawer', function () {
                    return !1;
                }),
                    this.nodes.$page.on(
                        'click.drawer',
                        $.proxy(function () {
                            return this.close(), !1;
                        }, this)
                    ),
                    $('.drawer .close-drawer').on(
                        'click',
                        $.proxy(function () {
                            return this.close(), !1;
                        }, this)
                    ),
                    this.nodes.$parent.on(
                        'keyup.drawer',
                        $.proxy(function (t) {
                            27 === t.keyCode && this.close();
                        }, this)
                    );
            }),
            (t.prototype.unbindEvents = function () {
                this.nodes.$page.off('.drawer'),
                    this.nodes.$parent.off('.drawer');
            }),
            t
        );
    })()),
    (window.Modals = (function () {
        var t = function (t, e, i) {
            var s = {
                close: '.js-modal-close',
                open: '.js-modal-open-' + e,
                openClass: 'modal--is-active',
            };
            if (((this.$modal = $('#' + t)), !this.$modal.length)) return !1;
            (this.nodes = { $body: $('body') }),
                (this.config = $.extend(s, i)),
                (this.modalIsOpen = !1),
                (this.$focusOnOpen = this.config.focusOnOpen
                    ? $(this.config.focusOnOpen)
                    : this.$modal),
                this.init();
        };
        return (
            (t.prototype.init = function () {
                $(this.config.open).attr('aria-expanded', 'false'),
                    $(this.config.open).on('click', $.proxy(this.open, this)),
                    this.$modal
                        .find(this.config.close)
                        .on('click', $.proxy(this.close, this));
            }),
            (t.prototype.open = function (t) {
                var e = !1;
                if (!this.modalIsOpen) {
                    if (
                        (t ? t.preventDefault() : (e = !0),
                        t &&
                            t.stopPropagation &&
                            (t.stopPropagation(),
                            (this.$activeSource = $(t.currentTarget))),
                        this.modalIsOpen && !e)
                    )
                        return this.close();
                    this.$modal
                        .prepareTransition()
                        .addClass(this.config.openClass),
                        this.nodes.$body.addClass(this.config.openClass),
                        (this.modalIsOpen = !0),
                        slate.a11y.trapFocus({
                            $container: this.$modal,
                            namespace: 'modal_focus',
                            $elementToFocus: this.$focusOnOpen,
                        }),
                        this.$activeSource &&
                            this.$activeSource.attr('aria-expanded') &&
                            this.$activeSource.attr('aria-expanded', 'true'),
                        this.bindEvents();
                }
            }),
            (t.prototype.close = function () {
                this.modalIsOpen &&
                    ($(document.activeElement).trigger('blur'),
                    this.$modal
                        .prepareTransition()
                        .removeClass(this.config.openClass),
                    this.nodes.$body.removeClass(this.config.openClass),
                    (this.modalIsOpen = !1),
                    slate.a11y.removeTrapFocus({
                        $container: this.$modal,
                        namespace: 'modal_focus',
                    }),
                    this.$activeSource &&
                        this.$activeSource.attr('aria-expanded') &&
                        this.$activeSource
                            .attr('aria-expanded', 'false')
                            .focus(),
                    this.unbindEvents());
            }),
            (t.prototype.bindEvents = function () {
                this.nodes.$body.on(
                    'keyup.modal',
                    $.proxy(function (t) {
                        27 === t.keyCode && this.close();
                    }, this)
                );
            }),
            (t.prototype.unbindEvents = function () {
                this.nodes.$body.off('.modal');
            }),
            t
        );
    })()),
    (window.QtySelector = (function () {
        var t = function (t) {
            (this.cache = {
                $body: $('body'),
                $subtotal: $('#CartSubtotal'),
                $discountTotal: $('#cartDiscountTotal'),
                $cartTable: $('.cart-table'),
                $cartTemplate: $('#CartProducts'),
            }),
                (this.settings = {
                    loadingClass: 'js-qty--is-loading',
                    isCartTemplate: this.cache.$body.hasClass('template-cart'),
                    minQty: this.cache.$body.hasClass('template-cart') ? 0 : 1,
                }),
                (this.$el = t),
                this.qtyUpdateTimeout,
                this.createInputs(),
                this.bindEvents();
        };
        return (
            (t.prototype.createInputs = function () {
                var t = this.$el,
                    e = {
                        value: t.val(),
                        key: t.attr('id'),
                        name: t.attr('name'),
                        line: t.attr('data-line'),
                    },
                    i = $('#QuantityTemplate').html(),
                    s = Handlebars.compile(i);
                (this.$wrapper = $(s(e)).insertBefore(t)), t.remove();
            }),
            (t.prototype.validateAvailability = function (t, e) {
                var i = theme.cartObject.items[t - 1],
                    s = i.handle,
                    a = i.id,
                    n = {
                        type: 'GET',
                        url: '/products/' + s + '.js',
                        dataType: 'json',
                        success: $.proxy(function (i) {
                            this.validateAvailabilityCallback(t, e, a, i);
                        }, this),
                    };
                $.ajax(n);
            }),
            (t.prototype.validateAvailabilityCallback = function (t, e, i, s) {
                for (var a = !0, n = 0; n < s.variants.length; n++) {
                    var o = s.variants[n];
                    if (o.id === i) break;
                }
                null !== o.inventory_management &&
                    'deny' === o.inventory_policy &&
                    o.inventory_quantity < e &&
                    (this.$wrapper
                        .find('.js-qty__input')
                        .val(o.inventory_quantity),
                    (a = !1),
                    this.$wrapper.removeClass(this.settings.loadingClass)),
                    a && this.updateItemQuantity(t, e);
            }),
            (t.prototype.validateQty = function (t) {
                return (
                    (parseFloat(t) !== parseInt(t, 10) || isNaN(t)) && (t = 1),
                    parseInt(t, 10)
                );
            }),
            (t.prototype.adjustQty = function (t) {
                var e = $(t.currentTarget),
                    i = e.siblings('.js-qty__input'),
                    s = this.validateQty(i.val()),
                    a = i.attr('data-line');
                e.hasClass('js-qty__adjust--minus')
                    ? (s -= 1) <= this.settings.minQty &&
                      (s = this.settings.minQty)
                    : (s += 1),
                    this.settings.isCartTemplate
                        ? (e.parent().addClass(this.settings.loadingClass),
                          this.updateCartItemPrice(a, s))
                        : i.val(s);
            }),
            (t.prototype.bindEvents = function () {
                this.$wrapper
                    .find('.js-qty__adjust')
                    .on('click', $.proxy(this.adjustQty, this)),
                    this.$wrapper.on('click', '.js-qty__input', function () {
                        this.setSelectionRange(0, this.value.length);
                    }),
                    this.settings.isCartTemplate &&
                        this.$wrapper.on(
                            'change',
                            '.js-qty__input',
                            $.proxy(function (t) {
                                var e = $(t.currentTarget),
                                    i = e.attr('data-line'),
                                    s = this.validateQty(e.val());
                                e.parent().addClass(this.settings.loadingClass),
                                    this.updateCartItemPrice(i, s);
                            }, this)
                        );
            }),
            (t.prototype.updateCartItemPrice = function (t, e) {
                clearTimeout(this.qtyUpdateTimeout),
                    (this.qtyUpdateTimeout = setTimeout(
                        $.proxy(function () {
                            this.validateAvailability(t, e);
                        }, this),
                        200
                    ));
            }),
            (t.prototype.updateItemQuantity = function (t, e) {
                var i = {
                    type: 'POST',
                    url: '/cart/change.js',
                    data: 'quantity=' + e + '&line=' + t,
                    dataType: 'json',
                    success: $.proxy(function (t) {
                        this.updateCartItemCallback(t);
                    }, this),
                };
                $.ajax(i);
            }),
            (t.prototype.updateCartItemCallback = function (e) {
                if (0 !== e.item_count) {
                    theme.cartObject = e;
                    var i,
                        s,
                        a = [],
                        n = {},
                        o = $('#CartProductTemplate').html(),
                        r = Handlebars.compile(o);
                    $.each(e.items, function (t, e) {
                        (s =
                            null === e.image
                                ? '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif'
                                : e.image
                                      .replace(/(\.[^.]*)$/, '_240x240$1')
                                      .replace('http:', '')),
                            null !== e.properties &&
                                $.each(e.properties, function (t, i) {
                                    ('_' !== t.charAt(0) && i) ||
                                        delete e.properties[t];
                                }),
                            (n = {
                                key: e.key,
                                line: t + 1,
                                url: e.url,
                                img: s,
                                name: e.product_title,
                                variation: e.variant_title,
                                properties: e.properties,
                                itemQty: e.quantity,
                                price: theme.Currency.formatMoney(
                                    e.price,
                                    theme.moneyFormat
                                ),
                                vendor: e.vendor,
                                linePrice: theme.Currency.formatMoney(
                                    e.line_price,
                                    theme.moneyFormat
                                ),
                                originalLinePrice: theme.Currency.formatMoney(
                                    e.original_line_price,
                                    theme.moneyFormat
                                ),
                                discounts: e.discounts,
                                discountsApplied:
                                    e.line_price !== e.original_line_price,
                            }),
                            a.push(n),
                            theme.updateCurrencies();
                    }),
                        (i = { items: a }),
                        this.cache.$cartTemplate.empty().append(r(i)),
                        this.cache.$cartTable
                            .find('input[type="number"]')
                            .each(function (e, i) {
                                new t($(i));
                            }),
                        this.cache.$subtotal.html(
                            theme.Currency.formatMoney(
                                e.total_price,
                                theme.moneyFormat
                            )
                        ),
                        e.total_discount > 0
                            ? this.cache.$discountTotal.html(
                                  theme.strings.totalCartDiscount.replace(
                                      '[savings]',
                                      theme.Currency.formatMoney(
                                          e.total_discount,
                                          theme.moneyFormat
                                      )
                                  )
                              )
                            : this.cache.$discountTotal.empty(),
                        theme.miniCart.updateElements(),
                        theme.updateCurrencies(),
                        slate.a11y.pageLinkFocus(this.cache.$cartTable);
                } else location.reload();
            }),
            t
        );
    })()),
    (window.AjaxCart = (function () {
        var t = $('.js-mini-cart').attr('data-cartmini'),
            e = function (t) {
                (this.cache = {
                    $cartIconIndicator: $('.site-header__cart-indicator'),
                }),
                    (this.$form = t),
                    this.eventListeners(),
                    (this.showNotice = !1),
                    this.$form.length &&
                        (this.showNotice =
                            !!this.$form.hasClass('js-form--notice'));
            };
        return (
            (e.prototype.eventListeners = function () {
                this.$form.length &&
                    this.$form.on(
                        'submit',
                        $.proxy(this.addItemFromForm, this)
                    );
            }),
            (e.prototype.addItemFromForm = function (t) {
                t.preventDefault();
                var e = {
                    type: 'POST',
                    url: '/cart/add.js',
                    data: this.$form.serialize(),
                    dataType: 'json',
                    success: $.proxy(function (t) {
                        this.success(t);
                    }, this),
                    error: $.proxy(function (t, e) {
                        this.error(t, e);
                    }, this),
                };
                $.ajax(e);
            }),
            (e.prototype.success = function (e) {
                if (
                    (theme.miniCart.updateElements(),
                    theme.miniCart.generateCart(),
                    'true' != t)
                )
                    if (this.showNotice) {
                        var i =
                                null !== e.variant_title
                                    ? '<i>(' + e.variant_title + ')</i>'
                                    : '',
                            s =
                                '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="' +
                                e.image +
                                '"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">' +
                                e.product_title +
                                ' x ' +
                                e.quantity +
                                '</p>' +
                                i +
                                '<div><div>';
                        theme.alert.new(
                            theme.strings.addToCartSuccess,
                            s,
                            3e3,
                            'notice'
                        );
                    } else theme.crosssell.showPopup(e);
            }),
            (e.prototype.error = function (t) {
                var e = JSON.parse(t.responseText);
                e.message && theme.alert.new('', e.description, 3e3, 'warning');
            }),
            e
        );
    })()),
    (theme.customerTemplates = (function () {
        function t() {
            $('#RecoverPasswordForm').toggleClass('hide'),
                $('#CustomerLoginForm').toggleClass('hide');
        }
        return {
            init: function () {
                var e;
                '#recover' === window.location.hash && t(),
                    $('#RecoverPassword').on('click', function (e) {
                        e.preventDefault(), t();
                    }),
                    $('#HideRecoverPasswordLink').on('click', function (e) {
                        e.preventDefault(), t();
                    }),
                    $('.reset-password-success').length &&
                        $('#ResetSuccess').removeClass('hide'),
                    (e = $('#AddressNewForm')).length &&
                        (Shopify &&
                            new Shopify.CountryProvinceSelector(
                                'AddressCountryNew',
                                'AddressProvinceNew',
                                { hideElement: 'AddressProvinceContainerNew' }
                            ),
                        $('.address-country-option').each(function () {
                            var t = $(this).data('form-id'),
                                e = 'AddressCountry_' + t,
                                i = 'AddressProvince_' + t,
                                s = 'AddressProvinceContainer_' + t;
                            new Shopify.CountryProvinceSelector(e, i, {
                                hideElement: s,
                            });
                        }),
                        $('.address-new-toggle').on('click', function () {
                            e.toggleClass('hide');
                        }),
                        $('.address-edit-toggle').on('click', function () {
                            var t = $(this).data('form-id');
                            $('#EditAddress_' + t).toggleClass('hide');
                        }),
                        $('.address-delete').on('click', function () {
                            var t = $(this),
                                e = t.data('form-id'),
                                i = t.data('confirm-message');
                            confirm(
                                i ||
                                    'Are you sure you wish to delete this address?'
                            ) &&
                                Shopify.postLink('/account/addresses/' + e, {
                                    parameters: { _method: 'delete' },
                                });
                        }));
            },
        };
    })()),
    (theme.HeaderSection = (function () {
        return function () {
            theme.NavDrawer = new window.Drawers('NavDrawer', 'left');
        };
    })()),
    (theme.Product = (function () {
        var t = {
            smallBreakpoint: 750,
            productThumbIndex: 0,
            productThumbMax: 0,
            ajaxCart: !1,
            stockSetting: !1,
        };
        function e(e) {
            var i = (this.$container = $(e)),
                s = i.attr('data-section-id');
            (this.selectors = {
                originalSelectorId: '#ProductSelect-' + s,
                modal: 'ProductModal',
                productZoomImage: '#ProductZoomImg',
                addToCart: '#AddToCart-' + s,
                productPrice: '#ProductPrice-' + s,
                comparePrice: '#ComparePrice-' + s,
                addToCartText: '#AddToCartText-' + s,
                SKU: '.js-variant-sku',
                productImageContainers: '.product__photo-container-' + s,
                productImageWrappers: '.product__photo-wrapper-' + s,
                productThumbContainers: '.product-single__thumbnail-item-' + s,
                productThumbsWrapper: '.product-single__thumbnails-' + s,
                productThumbs: '.product-single__thumbnail-' + s,
                saleTag: '#ProductSaleTag-' + s,
                productStock: '#ProductStock-' + s,
                singleOptionSelector: '.single-option-selector-' + s,
                shopifyPaymentButton: '.shopify-payment-button',
                availability: '.product-single__availability',
                hurrify: '.js-hurrify',
            }),
                (this.settings = $.extend({}, t, {
                    sectionId: s,
                    ajaxCart: i.data('ajax'),
                    stockSetting: i.data('stock'),
                    enableHistoryState: i.data('enable-history-state') || !1,
                    namespace: '.product-' + s,
                })),
                $('#ProductJson-' + s).html() &&
                    ((this.productSingleObject = JSON.parse(
                        $('#ProductJson-' + s).html()
                    )),
                    this.addVariantInfo(),
                    this.init());
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                init: function () {
                    this._stringOverrides(),
                        this._initVariants(),
                        this._productZoomImage(),
                        this._productThumbSwitch(),
                        this._productThumbnailSlider(),
                        this._initQtySelector(),
                        this.settings.ajaxCart &&
                            (theme.AjaxCart = new window.AjaxCart(
                                $('#AddToCartForm-' + this.settings.sectionId)
                            ));
                },
                _stringOverrides: function () {
                    (window.productStrings = window.productStrings || {}),
                        $.extend(theme.strings, window.productStrings);
                },
                addVariantInfo: function () {
                    if (this.productSingleObject && this.settings.stockSetting)
                        for (
                            var t = JSON.parse(
                                    $(
                                        '#VariantJson-' +
                                            this.settings.sectionId
                                    ).html()
                                ),
                                e = 0;
                            e < t.length;
                            e++
                        )
                            $.extend(
                                this.productSingleObject.variants[e],
                                t[e]
                            );
                },
                _initVariants: function () {
                    var t = {
                        $container: this.$container,
                        enableHistoryState: this.settings.enableHistoryState,
                        product: this.productSingleObject,
                        singleOptionSelector:
                            this.selectors.singleOptionSelector,
                        originalSelectorId: this.selectors.originalSelectorId,
                    };
                    (this.variants = new slate.Variants(t)),
                        this.$container.on(
                            'variantChange' + this.settings.namespace,
                            this._updateAddToCartBtn.bind(this)
                        ),
                        this.$container.on(
                            'variantChange' + this.settings.namespace,
                            this._updateStickyCart.bind(this)
                        ),
                        this.$container.on(
                            'variantPriceChange' + this.settings.namespace,
                            this._updatePrice.bind(this)
                        ),
                        this.$container.on(
                            'variantSKUChange' + this.settings.namespace,
                            this._updateSKU.bind(this)
                        ),
                        this.$container.on(
                            'variantImageChange' + this.settings.namespace,
                            this._updateImages.bind(this)
                        );
                },
                _updateStock: function (t) {
                    if (this.settings.stockSetting) {
                        var e = $(this.selectors.productStock),
                            i = $(this.selectors.hurrify);
                        if (!t || !t.inventory_management)
                            return e.addClass('hide'), void i.addClass('hide');
                        if (
                            t.inventory_quantity < 10 &&
                            t.inventory_quantity > 0
                        )
                            return (
                                e
                                    .html(
                                        theme.strings.stockAvailable.replace(
                                            '1',
                                            t.inventory_quantity
                                        )
                                    )
                                    .removeClass('hide'),
                                void i
                                    .removeClass('hide')
                                    .find('.progress-bar')
                                    .css(
                                        'width',
                                        10 * t.inventory_quantity + '%'
                                    )
                            );
                        if (t.inventory_quantity <= 0 && t.incoming)
                            return (
                                e
                                    .html(
                                        theme.strings.willNotShipUntil.replace(
                                            '[date]',
                                            t.next_incoming_date
                                        )
                                    )
                                    .removeClass('hide'),
                                void i.addClass('hide')
                            );
                        e.addClass('hide'), i.addClass('hide');
                    }
                },
                _updateIncomingInfo: function (t) {
                    if (this.settings.stockSetting) {
                        var e = $(this.selectors.productStock);
                        t.incoming
                            ? e
                                  .html(
                                      theme.strings.willBeInStockAfter.replace(
                                          '[date]',
                                          t.next_incoming_date
                                      )
                                  )
                                  .removeClass('hide')
                            : e.addClass('hide');
                    }
                },
                _updateAddToCartBtn: function (t) {
                    var e = t.variant,
                        i = {
                            $addToCart: $(this.selectors.addToCart),
                            $addToCartText: $(this.selectors.addToCartText),
                        };
                    e
                        ? (theme.noticeSoldout.init(e),
                          e.available
                              ? (i.$addToCart
                                    .removeClass('btn--sold-out')
                                    .prop('disabled', !1),
                                i.$addToCartText.html(theme.strings.addToCart),
                                $(
                                    this.selectors.shopifyPaymentButton,
                                    this.$container
                                ).show(),
                                this._updateStock(e),
                                $(this.selectors.availability)
                                    .find('span')
                                    .text(theme.strings.available))
                              : (i.$addToCart
                                    .prop('disabled', !0)
                                    .addClass('btn--sold-out'),
                                i.$addToCartText.html(theme.strings.soldOut),
                                $(
                                    this.selectors.shopifyPaymentButton,
                                    this.$container
                                ).hide(),
                                this._updateIncomingInfo(e),
                                $(this.selectors.availability)
                                    .find('span')
                                    .text(theme.strings.soldOut)))
                        : (i.$addToCart
                              .prop('disabled', !0)
                              .removeClass('btn--sold-out'),
                          i.$addToCartText.html(theme.strings.unavailable),
                          $(this.selectors.availability)
                              .find('span')
                              .text(theme.strings.unavailable),
                          $(
                              this.selectors.shopifyPaymentButton,
                              this.$container
                          ).hide(),
                          this._updateStock());
                },
                _updatePrice: function (t) {
                    var e = t.variant;
                    e
                        ? ($(this.selectors.productPrice).html(
                              theme.Currency.formatMoney(
                                  e.price,
                                  theme.moneyFormat
                              )
                          ),
                          e.compare_at_price > e.price
                              ? ($(this.selectors.comparePrice)
                                    .html(
                                        theme.Currency.formatMoney(
                                            e.compare_at_price,
                                            theme.moneyFormat
                                        )
                                    )
                                    .removeClass('hide'),
                                $(this.selectors.saleTag).removeClass('hide'))
                              : ($(this.selectors.comparePrice).addClass(
                                    'hide'
                                ),
                                $(this.selectors.saleTag).addClass('hide')),
                          theme.updateCurrencies())
                        : $(this.selectors.comparePrice).addClass('hide');
                },
                _updateSKU: function (t) {
                    var e = t.variant;
                    e && $(this.selectors.SKU).html(e.sku);
                },
                _updateImages: function (t) {
                    var e = t.variant;
                    if (e && e.featured_image) {
                        var i = e.featured_image.id;
                        this.switchProductImage(i), this.setActiveThumbnail(i);
                    }
                },
                _updateStickyCart: function (t) {
                    var e = t.variant,
                        i = $('#js-sticky-price'),
                        s = $('#js-sticky-title'),
                        a = $('#js-sticky-img'),
                        n = $('#js-sticky-btn');
                    if (e) {
                        s.html(' - ' + e.title),
                            i.html(
                                theme.Currency.formatMoney(
                                    e.price,
                                    theme.moneyFormat
                                )
                            );
                        for (var o = 1; o <= 3; o++) {
                            var r = 'option' + o,
                                c = '#js-sticky-option-' + o;
                            if (null !== e[r]) {
                                var l = e[r];
                                $(c).val(l);
                            }
                        }
                        e.available
                            ? (n
                                  .prop('disabled', !1)
                                  .removeClass('btn--sold-out'),
                              n.html(theme.strings.addToCart))
                            : (n.prop('disabled', !0).addClass('btn--sold-out'),
                              n.html(theme.strings.soldOut)),
                            e.featured_image &&
                                a.attr(
                                    'src',
                                    theme.Images.getSizedImageUrl(
                                        e.featured_image.src,
                                        '200x'
                                    )
                                );
                    } else
                        s.html(' - ' + theme.strings.unavailable),
                            n.prop('disabled', !0).removeClass('btn--sold-out'),
                            n.html(theme.strings.unavailable);
                },
                switchProductImage: function (t) {
                    var e = $(
                        this.selectors.productImageContainers +
                            "[data-image-id='" +
                            t +
                            "']",
                        this.$container
                    );
                    $(
                        this.selectors.productImageContainers +
                            ":not([data-image-id='" +
                            t +
                            "'])",
                        this.$container
                    ).addClass('hide'),
                        e.removeClass('hide'),
                        (topMenuHeight = $('.site-header').outerHeight()),
                        'product-template-8' === this.settings.sectionId &&
                            $([
                                document.documentElement,
                                document.body,
                            ]).animate(
                                { scrollTop: e.offset().top - topMenuHeight },
                                500
                            );
                },
                setActiveThumbnail: function (t) {
                    var e = $(
                        this.selectors.productThumbContainers +
                            "[data-image-id='" +
                            t +
                            "']",
                        this.$container
                    );
                    $(
                        this.selectors.productThumbContainers +
                            ":not([data-image-id='" +
                            t +
                            "'])",
                        this.$container
                    ).removeClass('is-active'),
                        e.addClass('is-active'),
                        e.trigger('click');
                    var i = $(
                        this.selectors.productThumbsWrapper,
                        this.$container
                    );
                    if (i.hasClass('slick-initialized')) {
                        var s = i.slick('slickCurrentSlide'),
                            a = parseInt(e.attr('data-slick-index'));
                        s !== a && i.slick('slickGoTo', a, !1);
                    }
                },
                _productZoomImage: function () {
                    if (
                        $(
                            '.product-single ' +
                                this.selectors.productImageContainers
                        ).length
                    ) {
                        var t = this;
                        $(this.selectors.productImageWrappers).on(
                            'click' + this.settings.namespace,
                            function (e) {
                                e.preventDefault(),
                                    $(t.selectors.productZoomImage)
                                        .attr('src', '')
                                        .attr('src', $(this).attr('href'));
                            }
                        ),
                            (this.ProductModal = new window.Modals(
                                this.selectors.modal,
                                'product-modal'
                            )),
                            this.ProductModal.$modal.on(
                                'click' + this.settings.namespace,
                                function (e) {
                                    'IMG' !== e.target.nodeName &&
                                        t.ProductModal.close();
                                }
                            );
                    }
                },
                _productThumbSwitch: function () {
                    if ($(this.selectors.productThumbs).length) {
                        var t = this;
                        $(this.selectors.productThumbs).on(
                            'click' + this.settings.namespace,
                            function (e) {
                                e.preventDefault();
                                var i = $(this).parent().data('image-id');
                                t.setActiveThumbnail(i),
                                    t.switchProductImage(i);
                            }
                        );
                    }
                },
                _productThumbnailSlider: function () {
                    var t = $(this.selectors.productThumbsWrapper),
                        e = $(this.selectors.productThumbs);
                    if (e.length && e.length > 1) {
                        if (
                            (t.on(
                                'init' + this.settings.namespace,
                                this._productSwipeInit.bind(this)
                            ),
                            'product-template-3' === this.settings.sectionId ||
                                'product-template-4' ===
                                    this.settings.sectionId)
                        )
                            t.slick({
                                accessibility: !1,
                                arrows: !0,
                                dots: !1,
                                infinite: !1,
                                autoplay: !1,
                                slidesToShow: 5,
                                slidesToScroll: 5,
                                vertical: !0,
                                verticalSwiping: !0,
                                responsive: [
                                    {
                                        breakpoint: 992,
                                        settings: {
                                            vertical: !1,
                                            verticalSwiping: !1,
                                            slidesToShow: 4,
                                            slidesToScroll: 4,
                                            dots: !1,
                                        },
                                    },
                                ],
                            }).css('opacity', '1');
                        else if (
                            'product-template-5' === this.settings.sectionId
                        )
                            t.slick({
                                accessibility: !1,
                                arrows: !0,
                                dots: !1,
                                infinite: !0,
                                autoplay: !1,
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                responsive: [
                                    {
                                        breakpoint: 992,
                                        settings: {
                                            slidesToShow: 4,
                                            slidesToScroll: 4,
                                            dots: !1,
                                        },
                                    },
                                ],
                            }).css('opacity', '1');
                        else if (
                            'product-template-7' === this.settings.sectionId
                        )
                            t.slick({
                                accessibility: !1,
                                arrows: !0,
                                dots: !0,
                                infinite: !0,
                                autoplay: !1,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                responsive: [
                                    {
                                        breakpoint: 992,
                                        settings: {
                                            slidesToShow: 1,
                                            slidesToScroll: 1,
                                            dots: !1,
                                            arrows: !0,
                                        },
                                    },
                                ],
                            }).css('opacity', '1');
                        else if (
                            'product-template-8' === this.settings.sectionId
                        ) {
                            var i,
                                s = $('.product-single__thumbnails'),
                                a = $('.site-header').outerHeight() + 20,
                                n = s.find('.product-single__thumbnail');
                            $(window).width() > 767
                                ? (n.click(function (t) {
                                      var e = $(this).attr('href');
                                      return (
                                          (offsetTop =
                                              $(e).offset().top - a + 1),
                                          $('html, body')
                                              .stop()
                                              .animate(
                                                  { scrollTop: offsetTop },
                                                  200
                                              ),
                                          !1
                                      );
                                  }),
                                  (scrollItems = n.map(function () {
                                      var t = $($(this).attr('href'));
                                      if (t.length) return t;
                                  })),
                                  $(window).scroll(function () {
                                      var t = $(this).scrollTop() + a,
                                          e = scrollItems.map(function () {
                                              if ($(this).offset().top < t)
                                                  return this;
                                          }),
                                          s =
                                              (e = e[e.length - 1]) && e.length
                                                  ? e[0].id
                                                  : '';
                                      i !== s &&
                                          ((i = s),
                                          n
                                              .parent()
                                              .removeClass('is-active')
                                              .end()
                                              .filter("[href='#" + s + "']")
                                              .parent()
                                              .addClass('is-active'));
                                  }))
                                : n.click(function (t) {
                                      var e = $(this).attr('href');
                                      return (
                                          (offsetTop = $(e).offset().top),
                                          $('html, body').stop().animate({
                                              scrollTop: offsetTop,
                                          }),
                                          !1
                                      );
                                  }),
                                t
                                    .slick({
                                        accessibility: !1,
                                        arrows: !0,
                                        dots: !1,
                                        infinite: !1,
                                        autoplay: !1,
                                        slidesToShow: 5,
                                        slidesToScroll: 1,
                                        vertical: !0,
                                        verticalSwiping: !0,
                                        responsive: [
                                            {
                                                breakpoint: 992,
                                                settings: {
                                                    vertical: !1,
                                                    verticalSwiping: !1,
                                                    slidesToShow: 4,
                                                    slidesToScroll: 4,
                                                    dots: !0,
                                                },
                                            },
                                        ],
                                    })
                                    .css('opacity', '1');
                        } else
                            t.slick({
                                accessibility: !1,
                                arrows: !0,
                                dots: !1,
                                infinite: !1,
                                autoplay: !1,
                                slidesToShow: 4,
                                slidesToScroll: 4,
                            }).css('opacity', '1');
                        t.slick(
                            'slickGoTo',
                            t.find('.is-active').attr('data-slick-index'),
                            !0
                        );
                    }
                },
                _productSwipeInit: function (t, e) {
                    (this.settings.productThumbIndex = e.currentSlide),
                        (this.settings.productThumbMax = e.slideCount - 1);
                    var i = this;
                    $(this.selectors.productImageWrappers).on(
                        'swipeleft swiperight',
                        function (t) {
                            'swipeleft' === t.type && i._goToNextThumbnail(),
                                'swiperight' === t.type &&
                                    i._goToPrevThumbnail(),
                                $(
                                    '.product-single__thumbnail-item[data-slick-index="' +
                                        i.settings.productThumbIndex +
                                        '"]'
                                )
                                    .find('.product-single__thumbnail')
                                    .trigger('click');
                        }
                    );
                },
                _goToNextThumbnail: function () {
                    this.settings.productThumbIndex++,
                        this.settings.productThumbIndex >
                            this.settings.productThumbMax &&
                            (this.settings.productThumbIndex = 0),
                        $(this.selectors.productThumbsWrapper).slick(
                            'slickGoTo',
                            this.settings.productThumbIndex,
                            !0
                        );
                },
                _goToPrevThumbnail: function () {
                    this.settings.productThumbIndex--,
                        this.settings.productThumbIndex < 0 &&
                            (this.settings.productThumbIndex =
                                this.settings.productThumbMax),
                        $(this.selectors.productThumbsWrapper).slick(
                            'slickGoTo',
                            this.settings.productThumbIndex,
                            !0
                        );
                },
                _initQtySelector: function () {
                    this.$container
                        .find('.product-form__quantity')
                        .each(function (t, e) {
                            new QtySelector($(e));
                        });
                },
                onUnload: function () {
                    $(this.selectors.productImageWrappers).off(
                        this.settings.namespace
                    ),
                        $(this.selectors.productThumbs).off(
                            this.settings.namespace
                        ),
                        $(this.selectors.productThumbs).slick('unslick'),
                        this.ProductModal &&
                            this.ProductModal.$modal.off(
                                this.settings.namespace
                            );
                },
            })),
            e
        );
    })()),
    (theme.Slideshow = (function () {
        this.$slideshow = null;
        var t = {
                slideshow: 'slideshow',
                slickActiveMobile: 'slick-active-mobile',
                controlsHover: 'slideshow__controls--hover',
                isPaused: 'is-paused',
            },
            e = {
                section: '.shopify-section',
                wrapper: '#SlideshowWrapper-',
                slides: '.slideshow__slide',
                textWrapperMobile: '.slideshow__text-wrap--mobile',
                textContentMobile: '.slideshow__text-content--mobile',
                controls: '.slideshow__controls',
                dots: '.slick-dots',
                arrowLeft: '.slideshow__arrow-left',
                arrowRight: '.slideshow__arrow-right',
            };
        function i(i, s) {
            this.$slideshow = $(i);
            (this.adaptHeight = this.$slideshow.data('adapt-height')),
                (this.$wrapper = this.$slideshow.closest(e.wrapper + s)),
                (this.$section = this.$wrapper.closest(e.section)),
                (this.$controls = this.$wrapper.find(e.controls)),
                (this.$textWrapperMobile = this.$section.find(
                    e.textWrapperMobile
                )),
                (this.autorotate = this.$slideshow.data('autorotate'));
            var a = this.$slideshow.data('speed');
            this.$slideshow.data('slide-nav-a11y');
            (this.settings = {
                rtl: theme.rtl,
                accessibility: !0,
                arrows: !0,
                dots: !0,
                fade: !theme.rtl,
                draggable: !0,
                touchThreshold: 20,
                autoplay: this.autorotate,
                autoplaySpeed: a,
            }),
                this.$slideshow.on(
                    'beforeChange',
                    function (e, i, s, a) {
                        var n = this.$dots.find('a'),
                            o = this.$mobileDots.find('li');
                        n
                            .removeAttr('aria-current')
                            .eq(a)
                            .attr('aria-current', 'true'),
                            o
                                .removeClass(t.slickActiveMobile)
                                .eq(a)
                                .addClass(t.slickActiveMobile),
                            this.showMobileText(a);
                    }.bind(this)
                ),
                this.$slideshow.on(
                    'init',
                    function (i, s) {
                        var a = s.$slider,
                            n = s.$list;
                        (this.$dots = this.$section.find(e.dots)),
                            (this.$mobileDots = this.$dots.eq(1)),
                            n.removeAttr('aria-live'),
                            this.$wrapper
                                .on(
                                    'focusin',
                                    function (t) {
                                        this.$wrapper.has(t.target).length &&
                                            (n.attr('aria-live', 'polite'),
                                            this.autorotate &&
                                                a.slick('slickPause'));
                                    }.bind(this)
                                )
                                .on(
                                    'focusout',
                                    function (t) {
                                        this.$wrapper.has(t.target).length &&
                                            n.removeAttr('aria-live');
                                    }.bind(this)
                                ),
                            this.$dots &&
                                this.$dots
                                    .find('a')
                                    .each(function () {
                                        var t = $(this);
                                        t.on('click keyup', function (t) {
                                            if (
                                                'keyup' !== t.type ||
                                                t.which ===
                                                    slate.utils.keyboardKeys
                                                        .ENTER
                                            ) {
                                                t.preventDefault();
                                                var e = $(t.target).data(
                                                    'slide-number'
                                                );
                                                a
                                                    .attr('tabindex', -1)
                                                    .slick('slickGoTo', e),
                                                    'keyup' === t.type &&
                                                        a.focus();
                                            }
                                        });
                                    })
                                    .eq(0)
                                    .attr('aria-current', 'true');
                        this.$controls
                            .on(
                                'focusin',
                                function () {
                                    this.$controls.addClass(t.controlsHover);
                                }.bind(this)
                            )
                            .on(
                                'focusout',
                                function () {
                                    this.$controls.removeClass(t.controlsHover);
                                }.bind(this)
                            );
                    }.bind(this)
                ),
                this.$slideshow.on(
                    'init',
                    function () {
                        this.$mobileDots
                            .find('li:first-of-type')
                            .addClass(t.slickActiveMobile),
                            this.showMobileText(0);
                    }.bind(this)
                ),
                this.adaptHeight &&
                    (this.setSlideshowHeight(),
                    $(window).resize(
                        $.debounce(50, this.setSlideshowHeight.bind(this))
                    )),
                this.$slideshow.slick(this.settings),
                function () {
                    this.$slideshow
                        .find(e.slides)
                        .removeAttr('role')
                        .removeAttr('aria-labelledby'),
                        this.$dots
                            .removeAttr('role')
                            .find('li')
                            .removeAttr('role')
                            .removeAttr('aria-selected')
                            .each(function () {
                                var t = $(this),
                                    e = t.attr('aria-controls');
                                t.removeAttr('aria-controls')
                                    .find('a')
                                    .attr('aria-controls', e);
                            });
                }.bind(this)();
        }
        return (
            (i.prototype.setSlideshowHeight = function () {
                var t = this.$slideshow.data('min-aspect-ratio');
                this.$slideshow.height($(document).width() / t);
            }),
            (i.prototype.showMobileText = function (t) {
                var i = this.$textWrapperMobile.find(e.textContentMobile),
                    s = e.textContentMobile + '-' + t,
                    a = this.$textWrapperMobile.find(s);
                a.length || 1 !== this.$slideshow.find(e.slides).length
                    ? this.$textWrapperMobile.show()
                    : this.$textWrapperMobile.hide(),
                    i.hide(),
                    a.show();
            }),
            i
        );
    })()),
    (theme.slideshows = {}),
    (theme.SlideshowSection = (function () {
        return function (t) {
            var e = (this.$container = $(t)).attr('data-section-id'),
                i = (this.slideshow = '#Slideshow-' + e);
            theme.slideshows[i] = new theme.Slideshow(i, e);
        };
    })()),
    (theme.SlideshowSection.prototype = _.assignIn(
        {},
        theme.SlideshowSection.prototype,
        {
            onUnload: function () {
                delete theme.slideshows[this.slideshow];
            },
            onBlockSelect: function (t) {
                var e = $(this.slideshow);
                e.data('adapt-height') &&
                    theme.slideshows[this.slideshow].setSlideshowHeight();
                var i = $(
                    '.slideshow__slide--' +
                        t.detail.blockId +
                        ':not(.slick-cloned)'
                ).data('slick-index');
                e.slick('slickGoTo', i).slick('slickPause');
            },
            onBlockDeselect: function () {
                $(this.slideshow).slick('slickPlay');
            },
        }
    )),
    (theme.slideshows = {}),
    (theme.Cart = (function () {
        var t = '#CartSpecialInstructions',
            e = '.cart__quantity',
            i = 'cart--no-cookies';
        function s(t) {
            var e = (this.$container = $(t)),
                i = e.attr('data-section-id');
            (theme.cartObject = JSON.parse($('#CartJson-' + i).html())),
                this.init(e);
        }
        return (
            (s.prototype = _.assignIn({}, s.prototype, {
                init: function (t) {
                    this._initQtySelector(),
                        this._initCartNote(),
                        this._cookiesEnabled() || t.addClass(i);
                },
                _initQtySelector: function () {
                    $(e).each(function (t, e) {
                        new QtySelector($(e));
                    });
                },
                _initCartNote: function () {
                    if ($(t).length) {
                        var e,
                            i,
                            s = $(t),
                            a = s[0].offsetHeight - s[0].clientHeight;
                        s.on('keyup input', function () {
                            $(this)
                                .css('height', 'auto')
                                .css('height', s[0].scrollHeight + a);
                        }),
                            s.on(
                                'change',
                                $.proxy(function () {
                                    (e = s.val()),
                                        (i = {
                                            type: 'POST',
                                            url: '/cart/update.js',
                                            data:
                                                'note=' +
                                                this._attributeToString(e),
                                            dataType: 'json',
                                        }),
                                        $.ajax(i);
                                }, this)
                            );
                    }
                },
                _attributeToString: function (t) {
                    return (
                        'string' != typeof t &&
                            'undefined' === (t = String(t)) &&
                            (t = ''),
                        $.trim(t)
                    );
                },
                _cookiesEnabled: function () {
                    var t = navigator.cookieEnabled;
                    return (
                        t ||
                            ((document.cookie = 'testcookie'),
                            (t = -1 !== document.cookie.indexOf('testcookie'))),
                        t
                    );
                },
            })),
            s
        );
    })()),
    (theme.Instagrams = (function () {
        function t(t) {
            (this.$container = $(t).on('init', this._a11y.bind(this))),
                (this.settings = {
                    style: this.$container.data('style'),
                    accesstoken: this.$container.data('accesstoken'),
                    userid: this.$container.data('userid'),
                    limit: this.$container.data('limit'),
                    resolution: this.$container.data('resolution'),
                    target: this.$container.attr('id'),
                    rows: this.$container.data('rows'),
                    slidesToShow: this.$container.data('slidestoshow') || 1,
                    infinite: this.$container.data('infinite') || !1,
                    arrows: this.$container.data('arrows') || !1,
                    draggable: this.$container.data('draggable') || !1,
                    dots: this.$container.data('dots') || !1,
                }),
                (this.settings.slidesToShow1200 =
                    this.settings.slidesToShow - 1 > 1
                        ? this.settings.slidesToShow - 1
                        : 1),
                (this.settings.slidesToShow992 =
                    this.settings.slidesToShow - 2 > 1
                        ? this.settings.slidesToShow - 2
                        : 1),
                (this.settings.slidesToShow768 =
                    this.settings.slidesToShow - 3 > 1
                        ? this.settings.slidesToShow - 3
                        : 1),
                (this.settings.slidesToShow480 = 2);
            var e = this,
                i = $('#' + this.settings.target);
            if ('grid' === this.settings.style) var s = function () {};
            else if ('carousel' === this.settings.style)
                s = function () {
                    i.slick({
                        slidesToShow: e.settings.slidesToShow,
                        slidesToScroll: e.settings.slidesToShow,
                        arrows: e.settings.arrows,
                        dots: e.settings.dots,
                        draggable: e.settings.draggable,
                        infinite: e.settings.infinite,
                        rows: e.settings.rows,
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: e.settings.slidesToShow1200,
                                    slidesToScroll: e.settings.slidesToShow1200,
                                },
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: e.settings.slidesToShow992,
                                    slidesToScroll: e.settings.slidesToShow992,
                                },
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: e.settings.slidesToShow768,
                                    slidesToScroll: e.settings.slidesToShow768,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: e.settings.slidesToShow480,
                                    slidesToScroll: e.settings.slidesToShow480,
                                },
                            },
                        ],
                    });
                };
            // new Instafeed({get:"user",target:this.settings.target,userId:this.settings.userid,accessToken:this.settings.accesstoken,limit:this.settings.limit,resolution:this.settings.resolution,template:'<div class="col hv-image-brightness"><a class="instagram-item" href="{{link}}" target="_blank" id="{{id}}"><img alt="instagram image" class="transition lazyload" data-src="{{image}}" /></a></div>',after:s}).run()
        }
        return (
            (t.prototype = _.assignIn({}, t.prototype, {
                _a11y: function (t, e) {
                    var i = e.$list,
                        s = this.$container.parent();
                    i.removeAttr('aria-live'),
                        s.on('focusin', function (t) {
                            s.has(t.target).length &&
                                i.attr('aria-live', 'polite');
                        }),
                        s.on('focusout', function (t) {
                            s.has(t.target).length && i.removeAttr('aria-live');
                        });
                },
            })),
            t
        );
    })()),
    (theme.slickCarousel = (function () {
        function t(t) {
            (this.$container = $(t).on('init', this._a11y.bind(this))),
                (this.settings = {
                    rows: this.$container.data('rows') || 1,
                    slidesToShow: this.$container.data('slidestoshow') || 1,
                    slidesToScroll: this.$container.data('slidestoscroll') || 1,
                    infinite: this.$container.data('infinite') || !1,
                    arrows: this.$container.data('arrows') || !1,
                    dots: this.$container.data('dots') || !1,
                    autoplay: this.$container.data('autoplay') || !1,
                    draggable: this.$container.data('draggable') || !1,
                    accessibility: this.$container.data('accessibility') || !0,
                }),
                (this.settings.slidesToShow1200 =
                    this.settings.slidesToShow - 1 > 1
                        ? this.settings.slidesToShow - 1
                        : 1),
                (this.settings.slidesToShow992 =
                    this.settings.slidesToShow - 2 > 1
                        ? this.settings.slidesToShow - 2
                        : 1),
                (this.settings.slidesToShow768 =
                    this.settings.slidesToShow - 3 > 1
                        ? this.settings.slidesToShow - 3
                        : 1),
                (this.settings.slidesToShow480 =
                    this.settings.slidesToShow - 4 > 1
                        ? this.settings.slidesToShow - 4
                        : 1),
                (this.settings.slidesToScroll1200 =
                    this.settings.slidesToScroll - 1 > 1
                        ? this.settings.slidesToScroll - 1
                        : 1),
                (this.settings.slidesToScroll992 =
                    this.settings.slidesToScroll - 2 > 1
                        ? this.settings.slidesToScroll - 2
                        : 1),
                (this.settings.slidesToScroll768 =
                    this.settings.slidesToScroll - 3 > 1
                        ? this.settings.slidesToScroll - 3
                        : 1),
                (this.settings.slidesToScroll480 =
                    this.settings.slidesToScroll - 4 > 1
                        ? this.settings.slidesToScroll - 4
                        : 1),
                this.$container.slick({
                    rtl: theme.rtl,
                    rows: this.settings.rows,
                    slidesToShow: this.settings.slidesToShow,
                    slidesToScroll: this.settings.slidesToScroll,
                    arrows: this.settings.arrows,
                    dots: this.settings.dots,
                    autoplay: this.settings.autoplay,
                    accessibility: this.settings.accessibility,
                    draggable: this.settings.draggable,
                    infinite: this.settings.infinite,
                    adaptiveHeight: !0,
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: this.settings.slidesToShow1200,
                                slidesToScroll:
                                    this.settings.slidesToScroll1200,
                            },
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: this.settings.slidesToShow992,
                                slidesToScroll: this.settings.slidesToScroll992,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: this.settings.slidesToShow768,
                                slidesToScroll: this.settings.slidesToScroll768,
                            },
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: this.settings.slidesToScroll480,
                            },
                        },
                    ],
                });
        }
        return (
            (t.prototype = _.assignIn({}, t.prototype, {
                _a11y: function (t, e) {
                    var i = e.$list,
                        s = this.$container.parent();
                    i.removeAttr('aria-live'),
                        s.on('focusin', function (t) {
                            s.has(t.target).length &&
                                i.attr('aria-live', 'polite');
                        }),
                        s.on('focusout', function (t) {
                            s.has(t.target).length && i.removeAttr('aria-live');
                        });
                },
                _goToSlide: function (t) {
                    this.$container.slick('slickGoTo', t);
                },
                onUnload: function () {
                    delete this.$container;
                },
                onBlockSelect: function (t) {
                    var e = $(
                        '.carousel__slide-wrapper--' +
                            t.detail.blockId +
                            ':not(.slick-cloned)'
                    ).data('slick-index');
                    this._goToSlide(e);
                },
            })),
            t
        );
    })()),
    (theme.Productlists = (function () {
        function t(t) {
            (this.$container = $(t).on('init', this._a11y.bind(this))),
                (this.settings = {
                    slidesToShow: this.$container.data('slidestoshow') || 1,
                    rows: this.$container.data('rows') || 1,
                    arrows: this.$container.data('arrows') || !1,
                    dots: this.$container.data('dots') || !1,
                    draggable: this.$container.data('draggable') || !1,
                    infinite: this.$container.data('infinite') || !1,
                }),
                (this.settings.slidesToShow1200 =
                    this.settings.slidesToShow - 1 > 1
                        ? this.settings.slidesToShow - 1
                        : 1),
                (this.settings.slidesToShow992 =
                    this.settings.slidesToShow - 2 > 1
                        ? this.settings.slidesToShow - 2
                        : 1),
                (this.settings.slidesToShow768 =
                    this.settings.slidesToShow - 3 > 1
                        ? this.settings.slidesToShow - 3
                        : 1),
                (this.settings.slidesToShow480 = 2),
                this.$container
                    .slick({
                        rtl: theme.rtl,
                        accessibility: !0,
                        slidesToShow: this.settings.slidesToShow,
                        slidesToScroll: this.settings.slidesToShow,
                        rows: this.settings.rows,
                        arrows: this.settings.arrows,
                        dots: this.settings.dots,
                        infinite: this.settings.infinite,
                        draggable: this.settings.draggable,
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow:
                                        this.settings.slidesToShow1200,
                                    slidesToScroll:
                                        this.settings.slidesToShow1200,
                                },
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: this.settings.slidesToShow992,
                                    slidesToScroll:
                                        this.settings.slidesToShow992,
                                },
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: this.settings.slidesToShow768,
                                    slidesToScroll:
                                        this.settings.slidesToShow768,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: this.settings.slidesToShow480,
                                    slidesToScroll:
                                        this.settings.slidesToShow480,
                                },
                            },
                        ],
                    })
                    .css('opacity', '1');
        }
        return (
            (t.prototype = _.assignIn({}, t.prototype, {
                _a11y: function (t, e) {
                    var i = e.$list,
                        s = this.$container.parent();
                    i.removeAttr('aria-live'),
                        s.on('focusin', function (t) {
                            s.has(t.target).length &&
                                i.attr('aria-live', 'polite');
                        }),
                        s.on('focusout', function (t) {
                            s.has(t.target).length && i.removeAttr('aria-live');
                        });
                },
                _goToSlide: function (t) {
                    this.$container.slick('slickGoTo', t);
                },
                onUnload: function () {
                    delete this.$container;
                },
            })),
            t
        );
    })()),
    (theme.Producttabs = (function () {
        function t(t) {
            var e = this;
            (this.$container = $(t).on('init', this._a11y.bind(this))),
                (this.slickWrap = '.prdtab-content'),
                (this.settings = {
                    slidesToShow: this.$container.data('slidestoshow') || 1,
                    arrows: this.$container.data('arrows') || !1,
                    rows: this.$container.data('rows') || 1,
                    dots: this.$container.data('dots') || !1,
                    draggable: this.$container.data('draggable') || !1,
                    infinite: this.$container.data('infinite') || !1,
                }),
                (this.settings.slidesToShow1200 =
                    this.settings.slidesToShow - 1 > 1
                        ? this.settings.slidesToShow - 1
                        : 1),
                (this.settings.slidesToShow992 =
                    this.settings.slidesToShow - 2 > 1
                        ? this.settings.slidesToShow - 2
                        : 1),
                (this.settings.slidesToShow768 =
                    this.settings.slidesToShow - 3 > 1
                        ? this.settings.slidesToShow - 3
                        : 1),
                (this.settings.slidesToShow480 = 2),
                this._initSlick(),
                this.$container
                    .find('a[data-toggle="tab"]')
                    .on('shown.bs.tab', function (t) {
                        e._unSlick(), e._initSlick(), theme.tooltip.load();
                    });
        }
        return (
            (t.prototype = _.assignIn({}, t.prototype, {
                _a11y: function (t, e) {
                    var i = e.$list,
                        s = this.$container.parent();
                    i.removeAttr('aria-live'),
                        s.on('focusin', function (t) {
                            s.has(t.target).length &&
                                i.attr('aria-live', 'polite');
                        }),
                        s.on('focusout', function (t) {
                            s.has(t.target).length && i.removeAttr('aria-live');
                        });
                },
                _getSliderSettings: function () {
                    return {
                        rtl: theme.rtl,
                        accessibility: !0,
                        slidesToShow: this.settings.slidesToShow,
                        slidesToScroll: this.settings.slidesToShow,
                        arrows: this.settings.arrows,
                        rows: this.settings.rows,
                        dots: this.settings.dots,
                        infinite: this.settings.infinite,
                        draggable: this.settings.draggable,
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow:
                                        this.settings.slidesToShow1200,
                                    slidesToScroll:
                                        this.settings.slidesToShow1200,
                                },
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: this.settings.slidesToShow992,
                                    slidesToScroll:
                                        this.settings.slidesToShow992,
                                },
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: this.settings.slidesToShow768,
                                    slidesToScroll:
                                        this.settings.slidesToShow768,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: this.settings.slidesToShow480,
                                    slidesToScroll:
                                        this.settings.slidesToShow480,
                                },
                            },
                        ],
                    };
                },
                _initSlick: function () {
                    this.$container
                        .find(this.slickWrap)
                        .slick(this._getSliderSettings())
                        .css('opacity', '1');
                },
                _unSlick: function () {
                    this.$container.find(this.slickWrap).slick('unslick');
                },
                onUnload: function () {
                    delete this.$container;
                },
                onSelect: function () {
                    this._unSlick(), this._initSlick();
                },
                onBlockSelect: function (t) {
                    $('.nav-link-' + t.detail.blockId).tab('show'),
                        this._unSlick(),
                        this._initSlick();
                },
            })),
            t
        );
    })()),
    (theme.Video = (function () {
        var t,
            e,
            i = {
                promiseAPI: function () {
                    if (!t) {
                        var e = document.createElement('script');
                        e.src = 'https://www.youtube.com/iframe_api';
                        var i = document.getElementsByTagName('script')[0];
                        i.parentNode.insertBefore(e, i),
                            (t = $.Deferred(function (t) {
                                (window.onYouTubeIframeAPIReady = t.resolve),
                                    setTimeout(function () {
                                        t.reject(
                                            'Request for YouTube API timed out after 30 seconds.'
                                        );
                                    }, 3e4);
                            }));
                    }
                    return t;
                },
                promisePlayer: function (t, e) {
                    return this.promiseAPI().then(function () {
                        return $.Deferred(function (i) {
                            void 0 === window.YT &&
                                i.reject(
                                    "We're sorry, something went wrong. The YouTube API has not loaded correctly."
                                );
                            var s = new YT.Player(t, e);
                            s.addEventListener('onReady', function () {
                                i.resolve(s);
                            }),
                                setTimeout(function () {
                                    i.reject(
                                        'Request for YouTube player has timed out after 30 seconds.'
                                    );
                                }, 3e4);
                        });
                    });
                },
            },
            s = {
                promiseAPI: function () {
                    return (
                        e ||
                            (e = $.Deferred(function (t) {
                                var e = document.createElement('script');
                                (e.src =
                                    'https://player.vimeo.com/api/player.js'),
                                    (e.onload = e.onreadystatechange =
                                        function () {
                                            (this.readyState &&
                                                'complete' !==
                                                    this.readyState) ||
                                                t.resolve();
                                        });
                                var i =
                                    document.getElementsByTagName('script')[0];
                                i.parentNode.insertBefore(e, i),
                                    setTimeout(function () {
                                        t.reject(
                                            'Request for Vimeo API timed out after 30 seconds.'
                                        );
                                    }, 3e4);
                            })),
                        e
                    );
                },
                promisePlayer: function (t, e) {
                    return this.promiseAPI().then(function () {
                        return $.Deferred(function (i) {
                            void 0 === window.Vimeo &&
                                i.reject(
                                    "We're sorry, something went wrong. The Vimeo API has not loaded correctly."
                                );
                            var s = new window.Vimeo.Player(t, e);
                            setTimeout(function () {
                                i.reject(
                                    'Request for Vimeo player has timed out after 30 seconds.'
                                );
                            }, 3e4),
                                s.ready().then(function () {
                                    i.resolve(s);
                                });
                        });
                    });
                },
            },
            a = '.video-section__load-player-button',
            n = '.video-section__player-close',
            o = '.video-section__player',
            r = '.video-section__cover',
            c = '.video-section__error',
            l = '.video-section__body-overlay',
            d = 'body',
            h = 'video-section--loaded',
            u = 'video-section--error',
            m = 'video-playing';
        function p(t) {
            this.$container = $(t);
            var e = this.$container.attr('data-section-id');
            (this.namespace = '.' + e), this.onLoad();
        }
        return (
            (p.prototype = _.assignIn({}, p.prototype, {
                onLoad: function () {
                    this.$container
                        .on('click', a, this._loadPlayer.bind(this))
                        .on('click', n, this._closePlayer.bind(this))
                        .on('click', l, this._closePlayer.bind(this));
                },
                _loadPlayer: function () {
                    var t,
                        e = this.$container,
                        i = $(o, e),
                        s = this.$container.attr('data-video-type');
                    return (
                        'youtube' === s
                            ? (t = this._loadYoutubePlayer(i[0]))
                            : 'vimeo' === s &&
                              (t = this._loadVimeoPlayer(i[0])),
                        t
                            .then(this._onPlayerLoadReady.bind(this))
                            .fail(this._onPlayerLoadError.bind(this))
                    );
                },
                _loadYoutubePlayer: function (t) {
                    return i
                        .promisePlayer(t, {
                            videoId: this.$container.attr('data-video-id'),
                            ratio: 16 / 9,
                            playerVars: {
                                modestbranding: 1,
                                autoplay: 1,
                                showinfo: 0,
                                rel: 0,
                            },
                        })
                        .then(
                            function (t) {
                                this.player = t;
                            }.bind(this)
                        );
                },
                _loadVimeoPlayer: function (t) {
                    return s
                        .promisePlayer(t, {
                            id: this.$container.attr('data-video-id'),
                        })
                        .then(
                            function (t) {
                                (this.player = t), this.player.play();
                            }.bind(this)
                        );
                },
                _onPlayerLoadReady: function () {
                    $(n, this.$container).show().focus(),
                        $(r, this.$container).addClass(h),
                        this.$container.addClass(h),
                        this._setScrollPositionValues(),
                        $(d).addClass(m),
                        $(document).on(
                            'keyup' + this.namespace,
                            this._closeOnEscape.bind(this)
                        ),
                        $(window).on(
                            'resize' + this.namespace,
                            this._setScrollPositionValues.bind(this)
                        ),
                        slate.a11y.trapFocus({
                            $container: this.$container,
                            namespace: this.namespace,
                        });
                },
                _onPlayerLoadError: function (t) {
                    this.$container.addClass(u), $(c, this.$container).text(t);
                },
                _closeOnEscape: function (t) {
                    27 === t.keyCode &&
                        (this._closePlayer(), $(a, this.$container).focus());
                },
                _onScroll: function () {
                    var t = $(window).scrollTop();
                    (t > this.videoTop + 0.25 * this.videoHeight ||
                        t + this.windowHeight <
                            this.videoBottom - 0.25 * this.videoHeight) &&
                        requestAnimationFrame(this._closePlayer.bind(this));
                },
                _setScrollPositionValues: function () {
                    (this.videoHeight = this.$container.outerHeight(!0)),
                        (this.videoTop = this.$container.offset().top),
                        (this.videoBottom = this.videoTop + this.videoHeight),
                        (this.windowHeight = $(window).innerHeight());
                },
                _closePlayer: function () {
                    $(d).removeClass(m),
                        $(r, this.$container).removeClass(h),
                        this.$container.removeClass(h),
                        $(n, this.$container).hide(),
                        slate.a11y.removeTrapFocus({
                            $container: this.$container,
                            namespace: this.namespace,
                        }),
                        'function' == typeof this.player.destroy
                            ? this.player.destroy()
                            : 'function' == typeof this.player.unload &&
                              this.player.unload(),
                        $(document).off(this.namespace),
                        $(window).off(this.namespace);
                },
            })),
            p
        );
    })()),
    (theme.CollectionsList = (function () {
        function t(t) {
            var e = (this.$container = $(t));
            if (!e.is('[data-stretch-image]')) {
                var i = (this.namespace = '.' + e.attr('data-section-id')),
                    s = this;
                s._collectionListFix(),
                    $(window).on(
                        'resize' + i,
                        $.debounce(250, function () {
                            s._collectionListFix();
                        })
                    );
            }
        }
        return (
            (t.prototype = _.assignIn({}, t.prototype, {
                onUnload: function () {
                    $(window).off(this.namespace);
                },
                _collectionListFix: function () {
                    var t = this.$container.find('.grid').data('number-rows'),
                        e = this.$container.find('.featured-card');
                    if (!e.is('[data-stretch-image]'))
                        for (var i = 0; i < t; i++) {
                            var s = 0,
                                a = 0,
                                n = e.filter(
                                    "[data-row-number='" + (i + 1) + "']"
                                ),
                                o = n.find('.featured-card__header');
                            n.each(function () {
                                var t = $(this).find('.featured-card__title'),
                                    e = $(this).find('.featured-card__action'),
                                    i = $(this).find(
                                        '.featured-card__image-wrapper'
                                    ),
                                    n = t.outerHeight() + e.outerHeight() + 65,
                                    o = i.outerHeight();
                                n > a && (a = n), o > s && (s = o);
                            }),
                                o.outerHeight(a),
                                n.height(s + a + 40);
                        }
                },
            })),
            t
        );
    })()),
    (theme.ParrallaxImage = (function () {
        function t(t) {
            (this.container = t),
                (this.sectionId = $(t).attr('data-section-id')),
                (this.namespace = 'parallax-' + this.sectionId);
            var e = document.getElementsByClassName(
                'thumbnail' + this.sectionId
            );
            new simpleParallax(e, { scale: 1.5, delay: 0.6 });
        }
        return (
            (t.prototype = $.extend({}, t.prototype, {
                onUnload: function (t) {
                    new simpleParallax(images).destroy(),
                        delete theme.ParrallaxImage[this.namespace];
                },
            })),
            t
        );
    })()),
    (theme.init = function () {
        theme.customerTemplates.init(),
            slate.rte.wrapTable(),
            slate.rte.iframeReset(),
            slate.a11y.pageLinkFocus($(window.location.hash)),
            $('.in-page-link').on('click', function (t) {
                slate.a11y.pageLinkFocus($(t.currentTarget.hash));
            }),
            $('a[href="#"]').on('click', function (t) {
                t.preventDefault();
            }),
            AOS.init({
                startEvent: 'DOMContentLoaded',
                offset: 30,
                delay: 0,
                duration: 1e3,
                once: !0,
            }),
            window.addEventListener('load', function () {
                AOS.refresh();
            });
        var t = new theme.Sections();
        t.register('header', theme.HeaderSection),
            t.register('product', theme.Product),
            t.register('slideshow-section', theme.SlideshowSection),
            t.register('cart', theme.Cart),
            t.register('instagrams', theme.Instagrams),
            t.register('masonries', theme.Masonry),
            t.register('productlist', theme.Productlists),
            t.register('producttab', theme.Producttabs),
            t.register('slickCarousels', theme.slickCarousel),
            t.register('video', theme.Video),
            t.register('collections-list', theme.CollectionsList),
            t.register('parallax-image', theme.ParrallaxImage),
            t.register('bgcollection', theme.Bgcollection),
            t.register('textanimation', theme.HoverMenu),
            $(window).on('load', theme.articleImages),
            theme.passwordModalInit();
    }),
    (theme.articleImages = function () {
        var t = $('.rte--indented-images');
        t.length &&
            t.find('img').each(function (e, i) {
                var s = $(i),
                    a = s.attr('style');
                (a && 'float: none;' !== a) ||
                    (s.width() >= t.width() &&
                        s.parent('p').addClass('rte__image-indent'));
            });
    }),
    (theme.passwordModalInit = function () {
        var t = $('#LoginModal');
        t.length &&
            ((theme.PasswordModal = new window.Modals(
                'LoginModal',
                'login-modal',
                { focusOnOpen: '#Password' }
            )),
            t.find('.errors').length && theme.PasswordModal.open());
    }),
    (theme.cssVar = void cssVars()),
    (theme.ajaxSearch = (function () {
        var t,
            e = $('.js-ajaxsearch').find('input[name="q"]');
        $('.js-ajaxsearch')
            .css('position', 'relative')
            .each(function () {
                e.attr('autocomplete', 'off').bind('keyup change', function () {
                    var e = $(this).val(),
                        i =
                            ($(this).closest('form'),
                            '/search?type=product&q=*' + e + '*');
                    e.length > 2 &&
                        e !== $(this).attr('data-old-term') &&
                        ($(this).attr('data-old-term', e),
                        void 0 !== t && t.abort(),
                        (t = $.getJSON(i + '&view=json', function (t) {
                            $('.search-results').empty(),
                                0 === t.results_count
                                    ? $('.search-results').html(
                                          '<p class="text-center">' +
                                              theme.strings.ajaxSearchNoResult +
                                              '</p>'
                                      )
                                    : ($.each(t.results, function (t, e) {
                                          if (t < 6) {
                                              var i =
                                                      theme.Currency.formatMoney(
                                                          e.price,
                                                          theme.moneyFormat
                                                      ),
                                                  s = $(
                                                      '<a class="d-inline-flex ' +
                                                          t +
                                                          '"></a>'
                                                  )
                                                      .attr('href', e.url)
                                                      .append(
                                                          '<span class="image"><img src="' +
                                                              e.thumbnail +
                                                              '" /></span>'
                                                      )
                                                      .append(
                                                          '<div class="meta"><p class="title">' +
                                                              e.title +
                                                              '</p>' +
                                                              i +
                                                              '</div>'
                                                      )
                                                      .wrap(
                                                          '<div class="ajax-search-item"></div>'
                                                      );
                                              $('.search-results').append(
                                                  s.parent()
                                              ),
                                                  theme.updateCurrencies();
                                          }
                                      }),
                                      t.results_count > 6 &&
                                          $('.search-results').append(
                                              '<a class="btn btn--full" href="' +
                                                  i +
                                                  '">' +
                                                  theme.strings
                                                      .ajaxSearchViewAll +
                                                  ' (' +
                                                  t.results_count +
                                                  ')</a>'
                                          )),
                                $('.search-results')
                                    .addClass('active')
                                    .fadeIn(200);
                        })));
                });
            }),
            $(document).click(function (t) {
                var e = t.target;
                $(e).is('.js-ajaxsearch') ||
                    $(e).parents().is('.js-ajaxsearch') ||
                    $('.search-results').slideUp(300);
            });
    })()),
    (theme.quickview = (function () {
        var t = '';
        $(document).on('click', '.js-btn-quickview', function () {
            (t = $(this).data('handle')),
                $('#jsQuickview').removeClass().addClass('modal fade'),
                $('#qv-product-images').removeClass().empty(),
                $('.qv-product-options').empty(),
                $('#jsQuickview').addClass(t).data('handle', t),
                jQuery.getJSON('/products/' + t + '.js', function (e) {
                    var i = e.title,
                        s = e.type,
                        a = e.vendor,
                        n = 0,
                        o = 0,
                        r = e.description.slice(0, 90),
                        c = e.images,
                        l = (e.variants, e.options),
                        d = '/products/' + t;
                    $('.qv-product-title').text(i),
                        $('.qv-product-type').text(s),
                        $('.qv-product-description').html(r),
                        $('.qv-view-product').attr('href', d),
                        $('.qv-view-type').text(s),
                        $('.qv-view-vendor').text(a),
                        $(e.variants).each(function (t, i) {
                            null != i.sku
                                ? ($('.qv-sku')
                                      .addClass('show')
                                      .removeClass('hide'),
                                  $('.qv-view-sku').text(e.variants[0].sku))
                                : $('.qv-sku')
                                      .addClass('hide')
                                      .removeClass('show');
                        });
                    $(c).length;
                    $(c).each(function (t, e) {
                        (image_embed = '<div><img src="' + e + '"></div>'),
                            (image_embed = image_embed
                                .replace('.jpg', '_800x.jpg')
                                .replace('.png', '_800x.png')),
                            $('#qv-product-images').append(image_embed);
                    }),
                        $('#qv-product-images')
                            .slick({
                                rtl: theme.rtl,
                                dots: !0,
                                arrows: !0,
                                respondTo: 'min',
                                useTransform: !0,
                            })
                            .css('opacity', '1'),
                        'Default Title' !== e.variants[0].option1 &&
                            $(l).each(function (t, e) {
                                var i = e.name.replace(/ /g, '-').toLowerCase();
                                $('.qv-product-options').append(
                                    '<div class="option-selection ' +
                                        i +
                                        '"><span class="option text-uppercase font-weight-bold text-body">' +
                                        e.name +
                                        '</span><select class="option-' +
                                        t +
                                        ' option ' +
                                        i +
                                        '"></select></div>'
                                ),
                                    $(e.values).each(function (t, e) {
                                        $('.option.' + i).append(
                                            $('<option>', { value: e, text: e })
                                        );
                                    });
                            }),
                        $(e.variants).each(function (t, e) {
                            return (
                                0 == e.inventory_quantity ||
                                ((n = theme.Currency.formatMoney(
                                    e.price,
                                    theme.moneyFormat
                                )),
                                (o = theme.Currency.formatMoney(
                                    e.compare_at_price,
                                    theme.moneyFormat
                                )),
                                $('.qv-product-price').html(n),
                                null !== e.compare_at_price
                                    ? $('.qv-product-compare-price')
                                          .html(o)
                                          .show()
                                    : $('.qv-product-compare-price').hide(),
                                theme.updateCurrencies(),
                                $('select.option-0').val(e.option1),
                                $('select.option-1').val(e.option2),
                                $('select.option-2').val(e.option3),
                                !1)
                            );
                        });
                });
        }),
            $(document).on('click', '.qv-add-button', function () {
                t = $('#jsQuickview').data('handle');
                var e = $('.qv-quantity').val(),
                    i = '',
                    s = '';
                $('#jsQuickview select').each(function (t) {
                    i = '' == i ? $(this).val() : i + ' / ' + $(this).val();
                }),
                    jQuery.getJSON('/products/' + t + '.js', function (t) {
                        1 === t.variants.length
                            ? (s = t.variants[0].id)
                            : $(t.variants).each(function (t, e) {
                                  e.title == i && (s = e.id);
                              }),
                            jQuery
                                .post(
                                    '/cart/add.js',
                                    { quantity: e, id: s },
                                    null,
                                    'json'
                                )
                                .done(function (t) {
                                    var e =
                                        null !== t.variant_title
                                            ? '<i>(' + t.variant_title + ')</i>'
                                            : '';
                                    if (
                                        'true' !=
                                        $('.js-mini-cart').attr('data-cartmini')
                                    ) {
                                        var i =
                                            '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="' +
                                            t.image +
                                            '"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">' +
                                            t.product_title +
                                            ' x ' +
                                            t.quantity +
                                            '</p>' +
                                            e +
                                            '<div><div>';
                                        theme.alert.new(
                                            theme.strings.addToCartSuccess,
                                            i,
                                            3e3,
                                            'notice'
                                        );
                                    }
                                    theme.miniCart.updateElements(),
                                        theme.miniCart.generateCart();
                                })
                                .fail(function (t) {
                                    var e = t.responseJSON;
                                    theme.alert.new(
                                        '',
                                        e.description,
                                        3e3,
                                        'warning'
                                    );
                                });
                    });
            }),
            $(document).on('change', '#jsQuickview select', function () {
                var e = '';
                $('#jsQuickview select').each(function (t) {
                    e = '' == e ? $(this).val() : e + ' / ' + $(this).val();
                }),
                    jQuery.getJSON('/products/' + t + '.js', function (t) {
                        $(t.variants).each(function (t, i) {
                            if (i.title == e) {
                                if (null !== i.featured_image) {
                                    var s = i.featured_image.position - 1;
                                    $('#qv-product-images').slick(
                                        'slickGoTo',
                                        s
                                    );
                                }
                                var a = theme.Currency.formatMoney(
                                        i.price,
                                        theme.moneyFormat
                                    ),
                                    n = theme.Currency.formatMoney(
                                        i.compare_at_price,
                                        theme.moneyFormat
                                    );
                                $('.qv-product-price').html(a),
                                    $('.qv-product-compare-price').html(n),
                                    null != i.sku
                                        ? ($('.qv-sku')
                                              .addClass('show')
                                              .removeClass('hide'),
                                          $('.qv-view-sku').text(i.sku))
                                        : $('.qv-sku')
                                              .addClass('hide')
                                              .removeClass('show'),
                                    null !== i.compare_at_price
                                        ? $('.qv-product-compare-price')
                                              .html(n)
                                              .show()
                                        : $('.qv-product-compare-price').hide(),
                                    theme.updateCurrencies(),
                                    null === i.inventory_management
                                        ? $('.qv-add-button')
                                              .prop('disabled', !1)
                                              .val(theme.strings.addToCart)
                                        : i.inventory_quantity < 1
                                        ? $('.qv-add-button')
                                              .prop('disabled', !0)
                                              .val(theme.strings.soldOut)
                                        : $('.qv-add-button')
                                              .prop('disabled', !1)
                                              .val(theme.strings.addToCart);
                            }
                        });
                    });
            });
    })()),
    (theme.addCartButton = void $(document).on(
        'click',
        '.js-grid-cart',
        function () {
            var t = $(this),
                e = t.data('id');
            t.addClass('is-loading'),
                Shopify.addItem(e, 1, function (e) {
                    var i =
                            null !== e.variant_title
                                ? '<i>(' + e.variant_title + ')</i>'
                                : '',
                        s = $('.js-mini-cart').attr('data-cartmini');
                    if ('true' != s)
                        var a =
                            '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="' +
                            e.image +
                            '"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">' +
                            e.product_title +
                            ' x ' +
                            e.quantity +
                            '</p>' +
                            i +
                            '<div><div>';
                    theme.miniCart.updateElements(),
                        theme.miniCart.generateCart(),
                        setTimeout(function () {
                            'true' != s &&
                                theme.alert.new(
                                    theme.strings.addToCartSuccess,
                                    a,
                                    3e3,
                                    'notice'
                                ),
                                t.removeClass('is-loading');
                        }, 1e3);
                });
        }
    )),
    theme.enableCurrencies)
) {
    Currency.format = 'money_format';
    var shopCurrency = Shopify.currency.active,
        cookieCurrency = Currency.cookie.read();
    jQuery('span.money span.money').each(function () {
        jQuery(this).parent('span.money').removeClass('money');
    }),
        jQuery('span.money').each(function () {
            jQuery(this).attr(
                'data-currency-' + Shopify.currency.active,
                jQuery(this).html()
            );
        });
    var buttons = jQuery('#currencies a'),
        currentCurrencies = jQuery('.pre-currencies');
    if (null == cookieCurrency || cookieCurrency == shopCurrency)
        Currency.currentCurrency = shopCurrency;
    else {
        (Currency.currentCurrency = cookieCurrency),
            Currency.convertAll(shopCurrency, cookieCurrency),
            buttons.removeClass('selected'),
            jQuery(
                '#currencies a[data-currency=' + cookieCurrency + ']'
            ).addClass('selected');
        var htmlCurrently = jQuery(
            '#currencies a[data-currency=' + cookieCurrency + ']'
        ).html();
        currentCurrencies.html(htmlCurrently);
    }
    buttons.click(function () {
        buttons.removeClass('selected'), jQuery(this).addClass('selected');
        var t = jQuery(this).attr('data-currency'),
            e = jQuery(this).html();
        currentCurrencies.html(e),
            Currency.convertAll(Currency.currentCurrency, t);
    });
    var original_selectCallback = window.selectCallback,
        selectCallback = function (t, e) {
            original_selectCallback(t, e),
                Currency.convertAll(
                    shopCurrency,
                    jQuery('#currencies a.selected').attr('data-currency')
                );
        };
}
(theme.updateCurrencies = function () {
    Currency.convertAll(
        shopCurrency,
        jQuery('#currencies a.selected').attr('data-currency')
    );
}),
    (theme.miniCart = (function () {
        var t = '.js-mini-cart',
            e = $(t).attr('data-cartmini'),
            i = '.js-cart-count',
            s = '.js-mini-cart-content',
            a = '.js-cart-total',
            n = $('.js-cart-btn-checkout'),
            o = 5,
            r = '<div class="alert">' + theme.strings.cartEmpty + '</div>';
        function c() {
            Shopify.getCart(function (o) {
                0 === o.item_count
                    ? ($(s).html(r),
                      n.addClass('disabled'),
                      'true' === e && $(t).removeClass('active'))
                    : (n.removeClass('disabled'),
                      'true' === e && $(t).addClass('active')),
                    $(i).text(o.item_count),
                    $(a).html(
                        theme.Currency.formatMoney(
                            o.total_price,
                            theme.moneyFormat
                        )
                    ),
                    theme.freeShipping.load(o),
                    theme.updateCurrencies();
            });
        }
        /* Edited Cart Item Function to recognise Peanut Butter Balls as a free gift - DT 10/09/2025 */
        function l() {
            Shopify.getCart(function (t) {
                for (
                    var e = 0 === t.item_count ? r : '',
                        i = t.items.length,
                        n = i < o ? i : o,
                        c = 0;
                    c < n;
                    c++
                ) {
                    var l = t.items[c],
                        d = theme.Currency.formatMoney(
                            l.price,
                            theme.moneyFormat
                        );

                    (e += '<div class="mini-cart-item">'),
                        (e +=
                            '\t<a class="mini-cart-image" href="' +
                            l.url +
                            '">'),
                        (e += '\t\t<img src="' + l.image + '"/>'),
                        (e += '\t</a>'),
                        (e += '\t<div class="mini-cart-meta">'),
                        (e +=
                            '\t\t<p ><a href="' +
                            l.url +
                            '">' +
                            l.title +
                            '</a></p>');

                    if (l.title === "Free Gift When Spend $100") {
                        e += '\t\t<span class="free-gift">FREE</span>';
                    }

                    else if (l.title === "Rapid Loss Shaker") {
                        if (t.total_price > 15000) {
                            e += '\t\t<span class="free-gift">FREE</span>';
                        }else {
                        e +=
                            '\t\t<span>' +
                            d +
                            '</span><b> x ' +
                            l.quantity +
                            '</b>';
                        }
                    }
                    else {
                        e +=
                            '\t\t<span>' +
                            d +
                            '</span><b> x ' +
                            l.quantity +
                            '</b>';
                        } 

                    (e += '\t</div>'),
                        (e +=
                            '\t<button class="btn js-remove-mini-cart" data-id="' +
                            l.id +
                            '">&times;</button>'),
                        (e += '</div>');
                }
                i > o &&
                    (e +=
                        '<a class="js-btn-viewmore" href="/cart">' +
                        theme.strings.cartMore +
                        '(' +
                        (i - o) +
                        ')</a>'),
                    $(s).html(e),
                    $(a).html(
                        theme.Currency.formatMoney(
                            t.total_price,
                            theme.moneyFormat
                        )
                    ),
                    theme.updateCurrencies();
            });
        }
        /*function l() {
            Shopify.getCart(function (t) {
                for (
                    var e = 0 === t.item_count ? r : '',
                        i = t.items.length,
                        n = i < o ? i : o,
                        c = 0;
                    c < n;
                    c++
                ) {
                    var l = t.items[c],
                        d = theme.Currency.formatMoney(
                            l.price,
                            theme.moneyFormat
                        );
                        lineTotal = l.price * l.quantity;
                    (e += '<div class="mini-cart-item">'),
                        (e +=
                            '\t<a class="mini-cart-image" href="' +
                            l.url +
                            '">'),
                        (e += '\t\t<img src="' + l.image + '"/>'),
                        (e += '\t</a>'),
                        (e += '\t<div class="mini-cart-meta">'),
                        (e +=
                            '\t\t<p ><a href="' +
                            l.url +
                            '">' +
                            l.title +
                            '</a></p>'),
                        (e +=
                            '\t\t<span> ' +
                            d +
                            '</span><b> x ' +
                            l.quantity +
                           
                            '</b>'),
                        (e += '\t</div>'),
                        (e +=
                            '\t<button class="btn js-remove-mini-cart" data-id="' +
                            l.id +
                            '">&times;</button>'),
                        (e += '</div>');
                }
                i > o &&
                    (e +=
                        '<a class="js-btn-viewmore" href="/cart">' +
                        theme.strings.cartMore +
                        '(' +
                        (i - o) +
                        ')</a>'),
                    $(s).html(e),
                    $(a).html(
                        theme.Currency.formatMoney(
                            t.total_price,
                            theme.moneyFormat
                        )
                    ),
                    theme.updateCurrencies();
            });
        }*/
        return (
            $(document).on('click', '.js-remove-mini-cart', function () {
                var e = $(this).data('id'),
                    i = 0 === $(this).closest(t).length;
                $(this).parent().fadeOut(),
                    Shopify.changeItem(e, 0, c),
                    Shopify.getCart(function (t) {
                        (t.items.length > o || i) && l();
                    });
            }),
            $(document).on('click', '.js-toggle-cart', function () {
                $(this).parent(t).toggleClass('active');
            }),
            $(document).on('click', '.overlaycart', function () {
                $(this).parent(t).removeClass('active');
            }),
            l(),
            { updateElements: c, generateCart: l }
        );
    })()),
    (theme.freeShipping = (function () {
        var t = $('.js-free-shipping'),
            e = $('.js-free-shipping-text'),
            i = parseInt(t.data('value')) || 0,
            s = $('.js-free-shipping .progress-bar');
        function a(t) {
            var a = t.total_price;
            if (a >= i)
                s
                    .css('width', '100%')
                    .removeClass('progress-bar-striped bg-primary'),
                    e.text(theme.strings.freeShipping);
            else {
                let t = (a / i) * 100,
                    n = Shopify.formatMoney(i - a, theme.moneyFormat);
                s
                    .css('width', t + '%')
                    .addClass('progress-bar-striped primary'),
                    e.html('Spend ' + n + ' for <b>FREE SHIPPING</b>'),
                    theme.updateCurrencies();
            }
        }
        return (
            Shopify.getCart(function (t) {
                a(t);
            }),
            { load: a }
        );
    })()),
    (theme.shippingTime = (function () {
        var t = $('.js-shipping-time'),
            e = t.data('time') || '',
            i = new Date(),
            s = 23 - i.getHours(),
            a = 59 - i.getMinutes();
        if ('' !== e) {
            var n = new Date(i.getTime() + 864e5 * e),
                o =
                    'Order in the next <b>' +
                    s +
                    '</b> hours <b>' +
                    a +
                    '</b> minutes to get it by <b>' +
                    $.format.date(n, 'ddd, dd MMMM yyyy') +
                    '</b>. ';
            t.html(o);
        }
    })()),
    (theme.infiniteScroll = (function () {
        function t() {
            if (0 !== $('.AjaxinateLoop').length)
                new Ajaxinate({
                    loadingText:
                        '<div class="text-center"><div class="' +
                        theme.loadingClass +
                        '" role="status"></div></div>',
                    callback: function () {
                        theme.wishlist.load(),
                            theme.compare.load(),
                            theme.countdown.load(),
                            theme.priceRange.load(),
                            theme.tooltip.load(),
                            theme.collectionView.triggerView(),
                            theme.swatchCard2.load();
                    },
                });
        }
        return (
            document.addEventListener('DOMContentLoaded', function () {
                t(),
                    new Ajaxinate({
                        loadingText:
                            '<div class="text-center"><div class="' +
                            theme.loadingClass +
                            '" role="status"></div></div>',
                        container: '.js-pagination-content',
                        pagination: '.js-pagination',
                    });
            }),
            { load: t }
        );
    })()),
    (theme.scrollToFixed = void $('.js-stick-parent').stick_in_parent()),
    (theme.headersidebar =
        ($('#dismiss, .overlaysidebar').on('click', function () {
            $('#sidebar').removeClass('active'),
                $('.overlaysidebar').removeClass('active');
        }),
        void $('#sidebarCollapse').on('click', function () {
            $('#sidebar').addClass('active'),
                $('.overlaysidebar').addClass('active'),
                $('.collapse.in').toggleClass('in'),
                $('a[aria-expanded=true]').attr('aria-expanded', 'false');
        }))),
    (theme.wishlist = (function () {
        var t = '.js-btn-wishlist',
            e = $('.js-wishlist-count'),
            i = $('.js-wishlist-content'),
            s = JSON.parse(localStorage.getItem('localWishlist')) || [],
            a = $('.js-wishlist-link').attr('href'),
            n = function () {
                i.html(
                    '<div class="col text-center"><div class="alert alert-warning d-inline-block">' +
                        theme.strings.wishlistNoResult +
                        '</div></div>'
                );
            };
        function o() {
            if ((i.html(''), s.length > 0))
                for (var a = 0; a < s.length; a++) {
                    var o = s[a];
                    Shopify.getProduct(o, function (t) {
                        var e = '',
                            s = t.price_varies
                                ? 'from ' +
                                  theme.Currency.formatMoney(
                                      t.price_min,
                                      theme.moneyFormat
                                  )
                                : theme.Currency.formatMoney(
                                      t.price,
                                      theme.moneyFormat
                                  ),
                            a =
                                0 !== t.compare_at_price_min
                                    ? theme.Currency.formatMoney(
                                          t.compare_at_price_min,
                                          theme.moneyFormat
                                      )
                                    : '';
                        (e +=
                            '<div class="js-wishlist-item col-md-4 col-sm-6 col-xs-6 col-12 mb-4">'),
                            (e += '<div class="js-wishlist-itembox">'),
                            (e += '<div class=" d-flex flex-row p-4">'),
                            (e +=
                                '\t<a class="d-inline-block mr-4 " href="' +
                                t.url +
                                '">'),
                            (e += '\t\t<img src="' + t.featured_image + '"/>'),
                            (e += '\t</a>'),
                            (e +=
                                '\t<div><a href=""' +
                                t.url +
                                '" class="title-prouct d-block h4 text-body" >' +
                                t.title +
                                '</a>'),
                            (e += '\t<span> ' + s + '</span>'),
                            (e += '\t <s>' + a + '</s></div>'),
                            (e +=
                                '<button class="btn js-remove-wishlist" data-handle="' +
                                t.handle +
                                '">' +
                                theme.strings.wishlistRemove +
                                '</button>'),
                            (e += '</div>'),
                            (e += '</div>'),
                            (e += '</div>'),
                            i.append(e),
                            theme.updateCurrencies();
                    });
                }
            else n();
            e.text(s.length),
                $(t).each(function () {
                    var t = $(this).data('handle'),
                        e =
                            -1 !== $.inArray(t, s)
                                ? theme.strings.wishlistIconAdded
                                : theme.strings.wishlistIcon,
                        i =
                            -1 !== $.inArray(t, s)
                                ? theme.strings.wishlistTextAdded
                                : theme.strings.wishlistText;
                    $(this)
                        .html(e + i)
                        .attr('title', i);
                });
        }
        return (
            $(document).on('click', t, function (i) {
                var n, o;
                i.preventDefault(),
                    (n = $(this).data('handle')),
                    (o = $(t + '[data-handle="' + n + '"]')),
                    -1 !== $.inArray(n, s)
                        ? (window.location.href = a)
                        : (s.push(n),
                          o
                              .fadeOut('slow')
                              .fadeIn('fast')
                              .html(
                                  theme.strings.wishlistIconAdded +
                                      theme.strings.wishlistTextAdded
                              ),
                          o.attr(
                              'data-original-title',
                              theme.strings.wishlistTextAdded
                          ),
                          $('.tooltip-inner').text(
                              theme.strings.wishlistTextAdded
                          )),
                    localStorage.setItem('localWishlist', JSON.stringify(s)),
                    e.text(s.length);
            }),
            $(document).on('click', '.js-remove-wishlist', function () {
                var i = $(this).data('handle'),
                    a = $(t + '[data-handle="' + i + '"]');
                a.html(theme.strings.wishlistIcon + theme.strings.wishlistText),
                    a.attr('data-original-title', theme.strings.wishlistText),
                    $('.tooltip-inner').text(theme.strings.wishlistText),
                    s.splice(s.indexOf(i), 1),
                    localStorage.setItem('localWishlist', JSON.stringify(s)),
                    $(this).closest('.js-wishlist-item').fadeOut(),
                    e.text(s.length),
                    0 === s.length && n();
            }),
            o(),
            $(document).on('shopify:section:load', o),
            { load: o }
        );
    })()),
    (theme.compare = (function () {
        var t = '.js-btn-compare',
            e = $('.js-compare-count'),
            i = $('.js-compare-content'),
            s = JSON.parse(localStorage.getItem('localCompare')) || [],
            a = 'notice';
        function n() {
            var a;
            if ((i.html(''), s.length > 0)) {
                a = 1 === s.length ? 'col-md-6 col-sm-6' : 'col';
                for (var n = 0; n < s.length; n++) {
                    var o = s[n];
                    Shopify.getProduct(o, function (t) {
                        var e = '',
                            s = t.price_varies
                                ? 'from ' +
                                  theme.Currency.formatMoney(
                                      t.price_min,
                                      theme.moneyFormat
                                  )
                                : theme.Currency.formatMoney(
                                      t.price,
                                      theme.moneyFormat
                                  ),
                            n =
                                0 !== t.compare_at_price_min
                                    ? theme.Currency.formatMoney(
                                          t.compare_at_price_min,
                                          theme.moneyFormat
                                      )
                                    : '',
                            o = t.available
                                ? theme.strings.available
                                : theme.strings.unavailable,
                            r = t.available ? 'alert-success' : 'alert-danger',
                            c =
                                '' !== t.type
                                    ? '<a href="/collections/types?q=' +
                                      t.type +
                                      '">' +
                                      t.type +
                                      '</a>'
                                    : '<span>' + theme.strings.none + '</span>',
                            l =
                                '' !== t.vendor
                                    ? '<a href="/collections/vendors?q=' +
                                      t.vendor +
                                      '">' +
                                      t.vendor +
                                      '</a>'
                                    : '<span>' + theme.strings.none + '</span>';
                        (e += '<div class="compare-item ' + a + ' col-xs-6">'),
                            (e += '\t<a href="' + t.url + '">'),
                            (e +=
                                '\t\t<img src="' +
                                Shopify.resizeImage(t.featured_image, 'x300') +
                                '"/>'),
                            (e += '\t</a>'),
                            (e += '\t<hr /><h5 >' + t.title + '</h5>'),
                            (e += '\t<hr /><s>' + n + '</s>'),
                            (e += '\t<span> ' + s + '</span>'),
                            (e +=
                                '\t<hr /><span class=' +
                                r +
                                '> ' +
                                o +
                                '</span>'),
                            (e += '\t<hr />' + c),
                            (e += '\t<hr />' + l),
                            (e +=
                                '  <hr /><button class="btn js-remove-compare btn-theme gradient-theme" data-handle="' +
                                t.handle +
                                '">' +
                                theme.strings.compareRemove +
                                '</button>'),
                            (e += '</div>'),
                            i.append(e),
                            theme.updateCurrencies();
                    });
                }
            } else
                i.html(
                    '<div class="alert alert-warning d-inline-block">' +
                        theme.strings.compareNoResult +
                        '</div>'
                );
            $(t).each(function () {
                var t = $(this).data('handle'),
                    e = -1 !== $.inArray(t, s) ? 'added' : '';
                $(this).removeClass('added').addClass(e);
            }),
                e.text(s.length);
        }
        return (
            $(document).on('click', t, function (t) {
                var i, o;
                t.preventDefault(),
                    (i = $(this).data('handle')),
                    (o = ''),
                    -1 !== $.inArray(i, s)
                        ? (s.splice(s.indexOf(i), 1),
                          (o = theme.strings.compareNotifyRemoved),
                          (a = 'notice'))
                        : 4 === s.length
                        ? ((o = theme.strings.compareNotifyMaximum),
                          (a = 'error'))
                        : ((a = 'notice'),
                          s.push(i),
                          (o = theme.strings.compareNotifyAdded)),
                    localStorage.setItem('localCompare', JSON.stringify(s)),
                    theme.alert.new(theme.strings.compareText, o, 2e3, a),
                    e.text(s.length),
                    n();
            }),
            $(document).on('click', '.js-remove-compare', function () {
                var t = $(this).data('handle');
                s.splice(s.indexOf(t), 1),
                    localStorage.setItem('localCompare', JSON.stringify(s)),
                    n();
            }),
            n(),
            $(document).on('shopify:section:load', n),
            { load: n }
        );
    })()),
    (theme.popupNewletter = (function () {
        var t = $('#jsPopupNewsletter'),
            e = $('#jsPopupNewsletter form'),
            i = new Date(),
            s = theme.timePopupNewsletter;
        if (1 === t.length) {
            i.setTime(i.getTime() + 60 * s * 1e3);
            var a = function () {
                $.cookie('cookiesNewsletter', 'disabled', {
                    expires: i,
                    path: '/',
                });
            };
            'disabled' !== $.cookie('cookiesNewsletter') &&
                ($(window).on('load', function () {
                    t.modal('show');
                }),
                t.on('hidden.bs.modal', a),
                e.submit(a));
        }
    })()),
    (theme.cookie = (function () {
        var t = $('.js-cookie-policy'),
            e = $('.js-btn-ok');
        '' === (localStorage.getItem('localCookie') || '') && t.fadeIn('slow'),
            e.on('click', function () {
                localStorage.setItem('localCookie', 'accept'),
                    t.fadeOut('slow');
            });
    })()),
    (theme.announcement = (function () {
        var t = $('.js-announcement-bar'),
            e = $('.js-ab-close');
        '' === (localStorage.getItem('localAnnouncement') || '') &&
            (t.fadeIn(),
            t.closest('.body-theme').addClass('body-announcement-bar')),
            e.on('click', function () {
                localStorage.setItem('localAnnouncement', 'closed'),
                    t.slideUp(),
                    t
                        .closest('.body-theme')
                        .removeClass('body-announcement-bar');
            });
    })()),
    (theme.exLink = (function () {
        var t = document.links;
        for (let e = 0, i = t.length; e < i; e++)
            t[e].hostname !== window.location.hostname &&
                'javascript:void(0)' !== $(t[e]).attr('href') &&
                (t[e].target = '_blank');
    })()),
    (theme.countdown = (function () {
        function t() {
            $('.js-countdown').each(function () {
                var t = $(this).data('time');
                $(this).lofCountDown({
                    TargetDate: t,
                    DisplayFormat:
                        "<ul class='list--inline'><li class='gradient-theme-vertical'><span class='countdown-time'>%%D%%</span><span class='countdown-text'>Days</span></li><li class='gradient-theme-vertical'><span class='countdown-time'>%%H%%</span><span class='countdown-text'>Hours</span></li><li class='gradient-theme-vertical'><span class='countdown-time'>%%M%%</span><span class='countdown-text'>Mins</span></li><li class='gradient-theme-vertical'><span class='countdown-time'>%%S%%</span><span class='countdown-text'>Secs</span></li></ul>",
                    FinishMessage:
                        '<span class="alert alert-warning d-inline-block">' +
                        theme.strings.countdownEndText +
                        '</span>',
                });
            });
        }
        return t(), { load: t };
    })()),
    (theme.priceRange = (function () {
        function initPriceRange() {
            var min = 0,
                max = 0,
                slideRange = '#js-slider-range',
                productCard = '.js-product-card',
                slideRangeWrap = '.slider-range-wr',
                rangeMin = '.js-range-min',
                rangeMax = '.js-range-max',
                enablePriceRange = 1 === $('#js-slider-range').length;
            if (enablePriceRange) {
                $(productCard).each(function () {
                    eval($(this).data('price')) > max &&
                        (max = eval($(this).data('price'))),
                        0 == min
                            ? (min = eval($(this).data('price')))
                            : eval($(this).data('price')) < min &&
                              (min = eval($(this).data('price')));
                }),
                    min === max
                        ? $(slideRangeWrap).fadeOut()
                        : $(slideRangeWrap).fadeIn(),
                    $(slideRange).slider({
                        range: !0,
                        min: min,
                        max: max,
                        values: [min, max],
                        slide: function (event, ui) {
                            var price1 = Shopify.formatMoney(
                                    ui.values[0],
                                    theme.moneyFormat
                                ),
                                price2 = Shopify.formatMoney(
                                    ui.values[1],
                                    theme.moneyFormat
                                );
                            $(rangeMin).html(price1),
                                $(rangeMax).html(price2),
                                theme.updateCurrencies(),
                                $(productCard).each(function () {
                                    eval($(this).data('price')) >=
                                        ui.values[0] &&
                                    eval($(this).data('price')) <= ui.values[1]
                                        ? $(this).parent().fadeIn()
                                        : $(this).parent().fadeOut();
                                });
                        },
                    });
                var price1 = Shopify.formatMoney(min, theme.moneyFormat),
                    price2 = Shopify.formatMoney(max, theme.moneyFormat);
                $(rangeMin).html(price1),
                    $(rangeMax).html(price2),
                    theme.updateCurrencies();
            }
        }
        return initPriceRange(), { load: initPriceRange };
    })()),
    (theme.collectionView = (function () {
        var t = '.js-btn-view.active';
        return (
            $(document).on('click', '.js-btn-view', function () {
                var t = $(this).data('col'),
                    e = $('.js-col');
                $('.js-btn-view').removeClass('active'),
                    $(this).addClass('active'),
                    e.removeClass().addClass('js-col col-sm-6 col-6'),
                    3 === t
                        ? e.addClass('col-lg-4')
                        : 4 === t
                        ? e.addClass('col-lg-3')
                        : 5 === t
                        ? e.addClass('col-lg-2-4')
                        : 6 === t && e.addClass('col-lg-2');
            }),
            {
                triggerView: function () {
                    $(t).trigger('click');
                },
            }
        );
    })()),
    (theme.swatchCard = void $(document).on(
        'click',
        '.js-swatch-card-item',
        function () {
            $('.js-swatch-card-item').removeClass('active'),
                $(this).addClass('active');
            var t = $(this).data('image'),
                e = $(this).data('id'),
                i = $(this).closest('.js-product-card');
            i.find('.product-card__image').find('img').attr('srcset', t),
                i.find('.js-grid-cart').data('id', e).attr('data-id', e);
        }
    )),
    (theme.swatchCard2 = (function () {
        function t() {
            $('.js-customform').each(function () {
                !(function (t) {
                    var e = JSON.parse($('.customJson-' + t).html()),
                        i = $('.customform-' + t),
                        s = $('.js-customform-addtocart-' + t),
                        a = s.find('span'),
                        n = i.closest('.js-product-card'),
                        o = {
                            $container: i,
                            enableHistoryState: !1,
                            product: e,
                            singleOptionSelector:
                                '.single-option-selector-' + t,
                            originalSelectorId: '#ProductSelect-' + t,
                        },
                        r = new slate.Variants(o);
                    new window.AjaxCart(i),
                        r.$container.on('variantChange', function (t) {
                            var e = t.variant;
                            void 0 === e
                                ? (s
                                      .prop('disabled', !0)
                                      .removeClass('btn--sold-out'),
                                  a.html(theme.strings.unavailable))
                                : e.available
                                ? (s
                                      .removeClass('btn--sold-out')
                                      .prop('disabled', !1),
                                  a.html(theme.strings.addToCart))
                                : (s
                                      .prop('disabled', !0)
                                      .addClass('btn--sold-out'),
                                  a.html(theme.strings.soldOut));
                        }),
                        r.$container.on('variantChange', function (t) {
                            var e = t.variant,
                                i = n.find('.product-card__image').find('img');
                            if (void 0 !== e && null !== e.featured_image) {
                                var s = e.featured_image;
                                i.attr('srcset', s.src);
                            }
                        }),
                        r.$container.on('variantChange', function (t) {
                            var e = n.find('.product-card__price'),
                                i = t.variant;
                            if (void 0 !== i) {
                                var s =
                                        null !== i.compare_at_price
                                            ? '<s class="product-card__regular-price"><span class="money">' +
                                              i.compare_at_price +
                                              '</span></s>'
                                            : '',
                                    a =
                                        '<span class="money">' +
                                        i.price +
                                        '</span>' +
                                        s;
                                e.html(a), theme.updateCurrencies();
                            }
                        });
                })($(this).data('id'));
            });
        }
        return t(), { load: t };
    })()),
    (theme.loading = (function () {
        var t = $('#js-loading');
        0 !== $('#js-loading').length &&
            $(window).load(function () {
                t.fadeOut();
            });
    })()),
    (theme.effectLeavingPage = void (window.onbeforeunload = function () {
        $('body').css('opacity', '0');
    })),
    (theme.isotope = (function () {
        var t = 1 === $('.enable-isotope').length,
            e = $('.js-grid'),
            i = '.js-filter-isotope';
        t &&
            (e.isotope({ itemSelector: '.grid-item', percentPosition: !0 }),
            $(document).on('click', i, function () {
                var t =
                    '*' === $(this).data('filter')
                        ? $(this).data('filter')
                        : '.' + $(this).data('filter');
                $(i).removeClass('active'),
                    $(this).addClass('active'),
                    e.isotope({ filter: t });
            }),
            $(window).scroll(function () {
                e.isotope('layout');
            }),
            $(window).load(function () {
                e.isotope('layout'), $(i).first().trigger('click');
            }));
    })()),
    (theme.Masonry = (function () {
        function t(t) {
            this.$container = $(t).on('init', this._a11y.bind(this));
            var e = this.$container;
            e.isotope({
                itemSelector: '.grid-item',
                percentPosition: !0,
                masonry: { columnWidth: '.grid-sizer' },
            }),
                $(window).load(function () {
                    e.isotope('layout').css('opacity', '1');
                }),
                $(window).scroll(function () {
                    e.isotope('layout').css('opacity', '1');
                });
        }
        return (
            (t.prototype = _.assignIn({}, t.prototype, {
                _a11y: function (t, e) {
                    var i = e.$list,
                        s = this.$container.parent();
                    i.removeAttr('aria-live'),
                        s.on('focusin', function (t) {
                            s.has(t.target).length &&
                                i.attr('aria-live', 'polite');
                        }),
                        s.on('focusout', function (t) {
                            s.has(t.target).length && i.removeAttr('aria-live');
                        });
                },
            })),
            t
        );
    })()),
    (theme.crosssell = (function () {
        var t = '.js-crosssell',
            e = $(t).data('handles') || '',
            i = e.split(','),
            s = $('.block-cross-sell');
        function a() {
            for (var e = 0; e < i.length; e++) {
                var s = i[e];
                Shopify.getProduct(s, function (e) {
                    for (
                        var i = '',
                            s = '',
                            a = '',
                            n = e.variants.length,
                            o = 0;
                        o < n;
                        o++
                    ) {
                        var r = e.variants[o],
                            c =
                                null === r.featured_image
                                    ? e.featured_image
                                    : r.featured_image.src;
                        (s +=
                            '<option ' +
                            (r.available ? '' : 'disabled') +
                            ' data-id="' +
                            r.id +
                            '" data-price="' +
                            r.price +
                            '" data-image="' +
                            c +
                            '">' +
                            r.title +
                            '</option>'),
                            '' === a && r.available && (a = r);
                    }
                    var l = theme.Currency.formatMoney(
                            a.price,
                            theme.moneyFormat
                        ),
                        d =
                            null === a.featured_image
                                ? e.featured_image
                                : a.featured_image.src,
                        h = 1 === n ? 'hide' : '';
                    (i += '<div class="col cross-item ' + e.handle + '">'),
                        (i +=
                            '\t<a class="cross-item-image" href="' +
                            e.url +
                            '" title="' +
                            e.title +
                            '"><img src="' +
                            d +
                            '" />' +
                            theme.strings.cartIcon +
                            '</a>'),
                        (i +=
                            '\t<a target="_blank" href="' +
                            e.url +
                            '" title="' +
                            e.title +
                            '" class="cross-item-title">' +
                            e.title +
                            '</a>'),
                        (i +=
                            '\t<span class="cross-item-money">' +
                            l +
                            '</span>'),
                        (i +=
                            '\t<select class="js-cross-select ' +
                            h +
                            '" data-image="' +
                            d +
                            '" data-price="' +
                            a.price +
                            '" data-item="' +
                            a.id +
                            '">' +
                            s +
                            '</select>'),
                        (i += '</div>'),
                        $(t).append(i),
                        theme.updateCurrencies();
                });
            }
        }
        function n(t) {
            var e = '';
            (e +=
                '<span class="alert alert-success d-inline-block mb-2">' +
                theme.strings.addToCartSuccess +
                '</span>'),
                (e +=
                    '<div><img src="' +
                    t.image +
                    '" alt="Added Product"></div>'),
                (e += '<h4 class="cross-item-title">' + t.title + '</h4>'),
                (e +=
                    '<div class="mb-2">' +
                    theme.strings.cartQuantity +
                    ': ' +
                    t.quantity +
                    '</div>'),
                $('.js-cross-added').hide().html(e).fadeIn(),
                $('#jsCrosssell').modal('show');
        }
        return (
            '' !== e &&
                ($(document).on('click', '.cross-item-image', function (t) {
                    t.preventDefault();
                    var e = $(this)
                        .closest('.cross-item')
                        .find('.js-cross-select')
                        .attr('data-item');
                    Shopify.addItem(e, 1, function (t) {
                        theme.miniCart.updateElements(),
                            theme.miniCart.generateCart(),
                            n(t);
                    });
                }),
                $(document).on('change', '.js-cross-select', function () {
                    var t = $(this).children(':selected'),
                        e = t.data('id'),
                        i = $(this).parent(),
                        s = theme.Currency.formatMoney(
                            t.data('price'),
                            theme.moneyFormat
                        );
                    '' !== t.data('image') &&
                        i
                            .find('.cross-item-image')
                            .find('img')
                            .attr('src', t.data('image')),
                        $(this).attr('data-item', e),
                        i.find('.cross-item-money').html(s),
                        theme.updateCurrencies();
                }),
                $(document).on('shopify:section:load', a),
                a(),
                s.removeClass('hide')),
            { showPopup: n }
        );
    })()),
    (theme.upsell = (function () {
        var t = $('#jsUpsell .btn'),
            e = $('#jsUpsell').data('id') || '',
            i = $('#jsUpsell').data('delay') || 3e3;
        1 === $('#jsUpsell').length &&
            ($(document).ready(function () {
                setTimeout(function () {
                    $('#jsUpsell').modal('show');
                }, i);
            }),
            t.on('click', function () {
                $(this).hasClass('js-btn-accept') &&
                    Shopify.addItem(e, 1, function (t) {
                        theme.miniCart.updateElements(),
                            theme.miniCart.generateCart();
                        var e =
                                null !== t.variant_title
                                    ? '<i>(' + t.variant_title + ')</i>'
                                    : '',
                            i =
                                '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="' +
                                t.image +
                                '"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">' +
                                t.product_title +
                                ' x ' +
                                t.quantity +
                                '</p>' +
                                e +
                                '<div><div>';
                        theme.alert.new(
                            theme.strings.addToCartSuccess,
                            i,
                            3e3,
                            'notice'
                        );
                    }),
                    $('#jsUpsell').modal('hide');
            }));
    })()),
    (theme.coupon = (function () {
        var t = $('#jsCoupon .js-btn-coupon'),
            e = $('#jsCoupon').data('delay') || 3e3,
            i = 1 === $('#jsCoupon').length,
            s = localStorage.getItem('localCoupon') || '';
        i &&
            '' === s &&
            ($(document).ready(function () {
                setTimeout(function () {
                    $('#jsCoupon').modal('show');
                }, e);
            }),
            t.on('click', function () {
                document.getElementById('coupon_code').select(),
                    document.execCommand('Copy'),
                    $('#jsCoupon').modal('hide'),
                    theme.alert.new(
                        'Coupon code',
                        'Successfully copied, now you can paste code at checkout',
                        4e3
                    ),
                    localStorage.setItem('localCoupon', 'copied');
            }));
    })()),
    (Shopify.onError = function (t, r) {
        var e = eval('(' + t.responseText + ')'),
            mess = e.message
                ? e.message + '(' + e.status + '): ' + e.description
                : 'Error : ' +
                  Shopify.fullMessagesFromErrors(e).join('; ') +
                  '.';
        theme.alert.new('Alert', mess, 3e3, 'warning');
    }),
    (theme.fixWidthMegamenu = void $('.site-nav__item-mega').each(function () {
        var t = $(this).data('width') || 0;
        0 !== t &&
            $(this)
                .find('.meganav')
                .css({ width: t + 'px', 'margin-left': '-' + t / 2 + 'px' });
    })),
    (theme.productVideo = void $(document).on(
        'click',
        '.js-play-button',
        function () {
            let t = $(this).next(),
                e = t.get(0);
            $(this).toggleClass('active'),
                t.toggleClass('active'),
                e.paused ? e.play() : e.pause();
        }
    )),
    (theme.fakeViewer = (function () {
        var t = $('.js-fake-view'),
            e = t.data('min'),
            i = t.data('max'),
            s = t.data('duration');
        function a(e, i) {
            var s = Math.floor(Math.random() * (i - e + 1) + e);
            t.text(s);
        }
        void 0 !== e &&
            void 0 !== i &&
            (a(e, i),
            setInterval(function () {
                a(e, i);
            }, s));
    })()),
    (theme.productSuggest = (function () {
        var t = $('.product-notification'),
            e = $('.close-notifi'),
            i = t.data('time') || 0,
            s = 'cookieSuggest';
        'closed' == $.cookie(s) && t.remove(),
            e.on('click', function () {
                t.remove(), $.cookie(s, 'closed', { expires: 1, path: '/' });
            }),
            0 !== i &&
                setInterval(function () {
                    if (t.hasClass('active')) t.removeClass('active');
                    else {
                        var e = $('.data-product'),
                            i = Math.floor(Math.random() * e.length),
                            s = $(e[i]);
                        t.addClass('active'),
                            t
                                .find('.product-image')
                                .attr('href', s.data('url'))
                                .find('img')
                                .attr('src', s.data('image')),
                            t
                                .find('.product-name')
                                .text(s.data('title'))
                                .attr('href', s.data('url')),
                            t.find('.time-ago').text(s.data('time')),
                            t.find('.from-ago').text(s.data('local'));
                    }
                }, i);
    })()),
    (theme.stickyHeader = (function () {
        if (0 !== $('.site-header--sticky').length) {
            var t =
                $('.site-header--sticky').offset().top +
                $('.site-header--sticky').height();
            $(window).scroll(function () {
                window.pageYOffset > t
                    ? $('.site-header--sticky').addClass('active')
                    : $('.site-header--sticky').removeClass('active');
            });
        }
    })()),
    (theme.PhotoSwipe = void (function (t) {
        for (
            var e = function (t) {
                    (t = t || window.event).preventDefault
                        ? t.preventDefault()
                        : (t.returnValue = !1);
                    var e = (function t(e, i) {
                        return e && (i(e) ? e : t(e.parentNode, i));
                    })(t.target || t.srcElement, function (t) {
                        return (
                            t.tagName && 'FIGURE' === t.tagName.toUpperCase()
                        );
                    });
                    if (e) {
                        for (
                            var s,
                                a = e.parentNode,
                                n = e.parentNode.childNodes,
                                o = n.length,
                                r = 0,
                                c = 0;
                            c < o;
                            c++
                        )
                            if (1 === n[c].nodeType) {
                                if (n[c] === e) {
                                    s = r;
                                    break;
                                }
                                r++;
                            }
                        return s >= 0 && i(s, a), !1;
                    }
                },
                i = function (t, e, i, s) {
                    var a,
                        n,
                        o = document.querySelectorAll('.pswp')[0];
                    if (
                        ((n = (function (t) {
                            for (
                                var e,
                                    i,
                                    s,
                                    a,
                                    n = t.childNodes,
                                    o = n.length,
                                    r = [],
                                    c = 0;
                                c < o;
                                c++
                            )
                                1 === (e = n[c]).nodeType &&
                                    ((s = (i = e.children[0])
                                        .getAttribute('data-size')
                                        .split('x')),
                                    (a = {
                                        src: i.getAttribute('href'),
                                        w: parseInt(s[0], 10),
                                        h: parseInt(s[1], 10),
                                    }),
                                    e.children.length > 1 &&
                                        (a.title = e.children[1].innerHTML),
                                    i.children.length > 0 &&
                                        (a.msrc =
                                            i.children[0].getAttribute('src')),
                                    (a.el = e),
                                    r.push(a));
                            return r;
                        })(e)),
                        (a = {
                            maxSpreadZoom: 1,
                            bgOpacity: 0.7,
                            zoomEl: !0,
                            history: !1,
                            zoomEl: !1,
                            pinchToClose: !1,
                            closeOnScroll: !1,
                            galleryUID: e.getAttribute('data-pswp-uid'),
                        }),
                        s)
                    )
                        if (a.galleryPIDs) {
                            for (var r = 0; r < n.length; r++)
                                if (n[r].pid == t) {
                                    a.index = r;
                                    break;
                                }
                        } else a.index = parseInt(t, 10) - 1;
                    else a.index = parseInt(t, 10);
                    isNaN(a.index) ||
                        (i && (a.showAnimationDuration = 0),
                        new PhotoSwipe(o, PhotoSwipeUI_Default, n, a).init());
                },
                s = document.querySelectorAll(t),
                a = 0,
                n = s.length;
            a < n;
            a++
        )
            s[a].setAttribute('data-pswp-uid', a + 1), (s[a].onclick = e);
        var o = (function () {
            var t = window.location.hash.substring(1),
                e = {};
            if (t.length < 5) return e;
            for (var i = t.split('&'), s = 0; s < i.length; s++)
                if (i[s]) {
                    var a = i[s].split('=');
                    a.length < 2 || (e[a[0]] = a[1]);
                }
            return e.gid && (e.gid = parseInt(e.gid, 10)), e;
        })();
        o.pid && o.gid && i(o.pid, s[o.gid - 1], !0, !0);
    })('.my-gallery')),
    (theme.ZoomImage = (function () {
        function t() {
            $('.zoom_image').each(function (t, e) {
                var i = $(e).find('img');
                $(e).zoom({
                    on: 'mouseover',
                    url: i.attr('src').replace('small', 'big'),
                });
            });
        }
        $(window).resize(function () {
            $(window).width() > 767 && t();
        }),
            $(window).width(function () {
                $(window).width() > 767 && t();
            });
    })()),
    (theme.activeAccordion =
        ($('.collapse').on('shown.bs.collapse', function () {
            $(this).prev().addClass('active-acc');
        }),
        void $('.collapse').on('hidden.bs.collapse', function () {
            $(this).prev().removeClass('active-acc');
        }))),
    (theme.HoverMenu = (function () {
        return function (t) {
            var e = (this.$container = $(t)).attr('data-section-id'),
                i = (this.slider = '.item_' + e);
            document.querySelectorAll(i).forEach((t) => {
                const e = t.querySelector('.img');
                t.addEventListener('mouseenter', (t) => {
                    gsap.to(e, {
                        ease: 'Expo.easeOut',
                        autoAlpha: 1,
                        scale: 1,
                        startAt: { scale: 0.6 },
                        scale: 1,
                    });
                }),
                    t.addEventListener('mouseleave', (t) => {
                        gsap.to(e, {
                            ease: 'Expo.easeOut',
                            autoAlpha: 0,
                            scale: 1,
                        });
                    }),
                    t.addEventListener('mousemove', (t) => {
                        gsap.set(e, {
                            ease: 'Expo.easeOut',
                            left: t.offsetX,
                            top: t.offsetY,
                            delay: 0,
                        });
                    });
            });
        };
    })()),
    (theme.anchorScroll = void $(document).on(
        'click',
        'a[href^="#"]',
        function (t) {
            t.preventDefault(),
                $(this).hasClass('disabled-anchor') ||
                    $('html, body').animate(
                        { scrollTop: $($.attr(this, 'href')).offset().top },
                        500
                    );
        }
    )),
    (theme.productRecentlyViewed = (function () {
        var t = $('.js-recently-view'),
            e = $('.js-recently-view-button'),
            i = $('.js-recently-view-content'),
            s = t.data('handle') || '',
            a = e.data('limit') || 0,
            n = JSON.parse(localStorage.getItem('localRecentlyViewed')) || [],
            o = n[n.length - 1] || '',
            r = -1 !== $.inArray(s, n);
        '' !== s &&
            (o === s && n.length > 1 && (o = n[n.length - 2]),
            r && n.splice(n.indexOf(s), 1),
            n.push(s),
            n.length > a && n.shift(),
            localStorage.setItem('localRecentlyViewed', JSON.stringify(n))),
            (function () {
                if ((i.html(''), n.length > 0)) {
                    for (var t = 0; t < n.length; t++) {
                        var s = n[t];
                        Shopify.getProduct(s, function (t) {
                            var e = '',
                                s = t.price_varies
                                    ? 'from ' +
                                      theme.Currency.formatMoney(
                                          t.price_min,
                                          theme.moneyFormat
                                      )
                                    : theme.Currency.formatMoney(
                                          t.price,
                                          theme.moneyFormat
                                      ),
                                a =
                                    0 !== t.compare_at_price_min
                                        ? theme.Currency.formatMoney(
                                              t.compare_at_price_min,
                                              theme.moneyFormat
                                          )
                                        : '';
                            (e +=
                                '<div class="col-12 col-lg-4 js-viewed-item mb-4">'),
                                (e +=
                                    '\t<div class="border p-3 rounded media d-flex ">'),
                                (e +=
                                    '\t<a class="mr-3 col-4 p-0" href="' +
                                    t.url +
                                    '">'),
                                (e +=
                                    '\t\t<img src="' +
                                    t.featured_image +
                                    '"/>'),
                                (e += '\t</a>'),
                                (e += '\t<div class="media-body text-left">'),
                                (e +=
                                    '\t\t<h4 class="mb-2 mt-2">' +
                                    t.title +
                                    '</h4>'),
                                (e += '\t<span> ' + s + '</span>'),
                                (e += '\t<s>' + a + '</s>'),
                                (e += '\t</div>'),
                                (e += '\t</div>'),
                                (e += '</div>'),
                                i.append(e),
                                theme.updateCurrencies();
                        });
                    }
                    Shopify.getProduct(o, function (t) {
                        e.css(
                            'background-image',
                            'url(' + t.featured_image + ')'
                        ).addClass('active');
                    });
                }
            })();
    })()),
    (theme.alert = (function () {
        return {
            new: function (t, e, i, s) {
                var a = t || '',
                    n = i || 2e3,
                    o = e || '',
                    r = s || 'default';
                $.growl({
                    title: a,
                    message: o,
                    duration: n,
                    style: r,
                    size: 'large',
                });
            },
        };
    })()),
    (theme.noticeSoldout = (function () {
        var t = $('.js-contact-soldout'),
            e = $('.js-notify-text'),
            i = $('#ContactProduct');
        return {
            init: function (s) {
                t.find('.form-success').remove(),
                    s.available
                        ? (e.find('span').text(''), t.addClass('hide'))
                        : (e.find('span').text(': ' + s.name),
                          t.removeClass('hide'),
                          i.val(s.name).attr('value', s.name));
            },
        };
    })()),
    (theme.stickyCart = (function () {
        var t = $('#js-anchor-sticky-cart'),
            e = $('.sticky-cart-wr'),
            i = $('#js-sticky-close'),
            s = localStorage.getItem('localDisableStCart') || '';
        '' !== s && e.addClass('disable'),
            i.on('click', function () {
                '' !== s
                    ? localStorage.setItem('localDisableStCart', '')
                    : localStorage.setItem('localDisableStCart', 'true'),
                    e.toggleClass('disable');
            }),
            t.length &&
                $(window).on('scroll', function () {
                    var i = t.offset().top,
                        s = t.outerHeight(),
                        a = $(window).height();
                    $(this).scrollTop() > i + s - a
                        ? e.addClass('active')
                        : e.removeClass('active');
                });
    })()),
    (theme.backToTop = (function () {
        var t = $('.js-back-to-top');
        $(window).scroll(function () {
            $(this).scrollTop() > 300 ? t.fadeIn('slow') : t.fadeOut('slow');
        }),
            t.on('click', function () {
                $('body,html').animate({ scrollTop: 0 }, 800);
            });
    })()),
    (theme.tooltip = (function () {
        var t = '[data-toggle="tooltip"],[data-tooltip="true"]';
        function e() {
            $(t).tooltip();
        }
        return (
            $(document).on('click', t, function () {
                $(this).tooltip('hide');
            }),
            e(),
            { load: e }
        );
    })()),
    (theme.Bgcollection = (function () {
        return function (t) {
            var e = (this.$container = $(t)).attr('data-section-id'),
                i = (this.wrapper = '.bgcollection-wrapper'),
                s = (this.slider = '#Bgcollection-' + e);
            $(s, i),
                $(".colgrid__bg--full[data-index='1']").addClass('active'),
                $('.colgrid .colgrid__box').each(function () {
                    var t = $(this).attr('data-index');
                    $(this).hover(
                        function () {
                            $(
                                ".colgrid__bg--full[data-index='" + t + "']"
                            ).addClass('active');
                        },
                        function () {
                            $(
                                ".colgrid__bg--full[data-index='" + t + "']"
                            ).removeClass('active');
                        }
                    );
                });
        };
    })()),
    (theme.sidebar = (function () {
        var t = $('.js-sidebar');
        $(document).on('click', '.js-toggle-filter', function () {
            t.toggleClass('active'), $(this).toggleClass('active');
        });
    })()),
    (theme.ajaxFilter = (function () {
        var t = $(document).find('title').text(),
            e = {
                init: function () {
                    this.initFilter();
                },
                showLoading: function () {
                    $('#js-loading').show();
                },
                hideLoading: function () {
                    $('body,html').animate(
                        { scrollTop: $('#js-product-ajax').offset().top },
                        600
                    ),
                        setTimeout(function () {
                            $('#js-loading').hide();
                        }, 500);
                },
                initFilter: function () {
                    e.filterParams(),
                        e.filterSortby(),
                        e.sidebarMapTagEvents(),
                        e.filterMapSorting(),
                        e.filterMapPaging();
                },
                filterParams: function () {
                    if (((Shopify.queryParams = {}), location.search.length))
                        for (
                            var t,
                                e = 0,
                                i = location.search.substr(1).split('&');
                            e < i.length;
                            e++
                        )
                            (t = i[e].split('=')).length > 1 &&
                                (Shopify.queryParams[decodeURIComponent(t[0])] =
                                    decodeURIComponent(t[1]));
                },
                filterSortby: function () {
                    if (Shopify.queryParams.sort_by) {
                        var t = Shopify.queryParams.sort_by;
                        $('#js-sortby').val(t);
                    }
                },
                filterCreateUrl: function (t) {
                    var e = $.param(Shopify.queryParams).replace(/%2B/g, '+');
                    return t
                        ? '' != e
                            ? t + '?' + e
                            : t
                        : location.pathname + '?' + e;
                },
                filterMapData: function (t) {
                    $('#js-product-ajax').html(
                        $('#js-product-ajax', t.responseText).html()
                    ),
                        $('#js-fillter').html(
                            $('#js-fillter', t.responseText).html()
                        ),
                        $('.js-collection-title').html(
                            $('.js-collection-title', t.responseText).html()
                        );
                },
                filterAjaxClick: function (i) {
                    delete Shopify.queryParams.page;
                    var s = e.filterCreateUrl(i);
                    History.pushState({ param: Shopify.queryParams }, t, s),
                        e.filterGetContent(s);
                },
                filterGetContent: function (t) {
                    $.ajax({
                        type: 'GET',
                        url: t,
                        data: {},
                        beforeSend: function () {
                            e.showLoading();
                        },
                        complete: function (t) {
                            e.filterMapData(t),
                                theme.wishlist.load(),
                                theme.compare.load(),
                                theme.countdown.load(),
                                theme.priceRange.load(),
                                theme.tooltip.load(),
                                theme.collectionView.triggerView(),
                                theme.swatchCard2.load(),
                                theme.infiniteScroll.load(),
                                e.hideLoading();
                        },
                        error: function (t, i) {
                            e.hideLoading(),
                                alert($.parseJSON(t.responseText).description);
                        },
                    });
                },
                sidebarMapTagEvents: function () {
                    $(document).on('click', '.advanced-filter a', function (t) {
                        t.preventDefault(), $('.tooltip').removeClass('show');
                        var i = [];
                        if (
                            (Shopify.queryParams.constraint &&
                                (i = Shopify.queryParams.constraint.split('+')),
                            !$(this).parent().hasClass('active-filter'))
                        ) {
                            var s = $(this)
                                .parents('.catalog_filter_ul')
                                .find('li.active-filter');
                            if (s.length > 0) {
                                var a = s.data('handle');
                                if (a)
                                    (n = i.indexOf(a)) >= 0 && i.splice(n, 1);
                            }
                        }
                        var n,
                            o = $(this).parent().data('handle');
                        o &&
                            ((n = i.indexOf(o)) >= 0
                                ? i.splice(n, 1)
                                : i.push(o));
                        i.length
                            ? (Shopify.queryParams.constraint = i.join('+'))
                            : delete Shopify.queryParams.constraint,
                            e.filterAjaxClick();
                    }),
                        $(document).on(
                            'click',
                            '.advanced-filter .icon',
                            function () {
                                $(this)
                                    .parent('.advanced-filter')
                                    .find('a')
                                    .trigger('click');
                            }
                        );
                },
                filterMapSorting: function () {
                    $(document).on('change', '#js-sortby', function () {
                        (Shopify.queryParams.sort_by = $(this).val()),
                            e.filterAjaxClick();
                    });
                },
                filterMapPaging: function () {
                    $(document).on('click', '.js-pagination a', function () {
                        event.preventDefault();
                        var i = $(this)
                            .attr('href')
                            .match(/page=\d+/g);
                        if (
                            i &&
                            ((Shopify.queryParams.page = parseInt(
                                i[0].match(/\d+/g)
                            )),
                            Shopify.queryParams.page)
                        ) {
                            var s = e.filterCreateUrl();
                            History.pushState(
                                { param: Shopify.queryParams },
                                t,
                                s
                            ),
                                e.filterGetContent(s);
                        }
                    });
                },
            };
        $('.template-collection') &&
            History.Adapter.bind(window, 'statechange', function () {
                History.getState();
                e.filterParams();
            }),
            e.init();
    })()),
    $(theme.init);
